function buildPartnerInquiryTranslations(copy) {
  return {
    "partnerInquiry.program.affiliate": copy.programAffiliate,
    "partnerInquiry.program.reseller": copy.programReseller,
    "partnerInquiry.program.cobranding": copy.programCobranding,
    "partnerInquiry.affiliate.seoTitle": copy.affiliateSeoTitle,
    "partnerInquiry.affiliate.seoDescription": copy.affiliateSeoDescription,
    "partnerInquiry.affiliate.badge": copy.affiliateBadge,
    "partnerInquiry.affiliate.title": copy.affiliateTitle,
    "partnerInquiry.affiliate.subtitle": copy.affiliateSubtitle,
    "partnerInquiry.affiliate.point1": copy.affiliatePoint1,
    "partnerInquiry.affiliate.point2": copy.affiliatePoint2,
    "partnerInquiry.affiliate.point3": copy.affiliatePoint3,
    "partnerInquiry.affiliate.messageLabel": copy.affiliateMessageLabel,
    "partnerInquiry.affiliate.submit": copy.affiliateSubmit,
    "partnerInquiry.affiliate.success": copy.affiliateSuccess,
    "partnerInquiry.reseller.seoTitle": copy.resellerSeoTitle,
    "partnerInquiry.reseller.seoDescription": copy.resellerSeoDescription,
    "partnerInquiry.reseller.badge": copy.resellerBadge,
    "partnerInquiry.reseller.title": copy.resellerTitle,
    "partnerInquiry.reseller.subtitle": copy.resellerSubtitle,
    "partnerInquiry.reseller.point1": copy.resellerPoint1,
    "partnerInquiry.reseller.point2": copy.resellerPoint2,
    "partnerInquiry.reseller.point3": copy.resellerPoint3,
    "partnerInquiry.reseller.messageLabel": copy.resellerMessageLabel,
    "partnerInquiry.reseller.submit": copy.resellerSubmit,
    "partnerInquiry.reseller.success": copy.resellerSuccess,
    "partnerInquiry.cobranding.seoTitle": copy.cobrandingSeoTitle,
    "partnerInquiry.cobranding.seoDescription": copy.cobrandingSeoDescription,
    "partnerInquiry.cobranding.badge": copy.cobrandingBadge,
    "partnerInquiry.cobranding.title": copy.cobrandingTitle,
    "partnerInquiry.cobranding.subtitle": copy.cobrandingSubtitle,
    "partnerInquiry.cobranding.point1": copy.cobrandingPoint1,
    "partnerInquiry.cobranding.point2": copy.cobrandingPoint2,
    "partnerInquiry.cobranding.point3": copy.cobrandingPoint3,
    "partnerInquiry.cobranding.messageLabel": copy.cobrandingMessageLabel,
    "partnerInquiry.cobranding.submit": copy.cobrandingSubmit,
    "partnerInquiry.cobranding.success": copy.cobrandingSuccess,
    "partnerInquiry.form.name": copy.formName,
    "partnerInquiry.form.email": copy.formEmail,
    "partnerInquiry.form.company": copy.formCompany,
    "partnerInquiry.form.website": copy.formWebsite,
    "partnerInquiry.form.channel": copy.formChannel,
    "partnerInquiry.form.audience": copy.formAudience,
    "partnerInquiry.form.region": copy.formRegion,
    "partnerInquiry.form.volume": copy.formVolume,
    "partnerInquiry.form.timeline": copy.formTimeline,
    "partnerInquiry.form.submitting": copy.formSubmitting,
    "partnerInquiry.validation.required": copy.validationRequired,
    "partnerInquiry.validation.email": copy.validationEmail,
    "partnerInquiry.error": copy.error,
    "partnerInquiry.prefill.affiliate": copy.prefillAffiliate,
    "partnerInquiry.prefill.reseller": copy.prefillReseller,
    "partnerInquiry.prefill.cobranding": copy.prefillCobranding,
  };
}

const partnerInquiryLocaleTranslations = {
  fr: buildPartnerInquiryTranslations({
    programAffiliate: "Affiliation",
    programReseller: "Revendeur",
    programCobranding: "Co-branding",
    affiliateSeoTitle: "Candidature affilié LUKKEY | Programme créateurs",
    affiliateSeoDescription: "Postulez pour rejoindre LUKKEY comme créateur ou partenaire affilié.",
    affiliateBadge: "Affiliation créateurs",
    affiliateTitle: "Devenez créateur partenaire LUKKEY.",
    affiliateSubtitle: "Une candidature rapide et conviviale pour créateurs, testeurs, formateurs et communautés.",
    affiliatePoint1: "Candidature simple pour les créateurs",
    affiliatePoint2: "Partagez votre canal et votre audience",
    affiliatePoint3: "L'équipe LUKKEY vous répondra par e-mail",
    affiliateMessageLabel: "Parlez-nous de votre contenu",
    affiliateSubmit: "Postuler comme créateur partenaire",
    affiliateSuccess: "Votre candidature créateur a été envoyée.",
    resellerSeoTitle: "Candidature revendeur LUKKEY | Partenariat B2B",
    resellerSeoDescription: "Postulez pour devenir revendeur LUKKEY ou partenaire de distribution.",
    resellerBadge: "Candidature revendeur",
    resellerTitle: "Postulez pour devenir revendeur LUKKEY.",
    resellerSubtitle: "Un formulaire B2B concis pour boutiques, distributeurs et canaux de vente.",
    resellerPoint1: "Profil d'entreprise et région de vente",
    resellerPoint2: "Adéquation du canal et volume attendu",
    resellerPoint3: "Suivi professionnel par l'équipe partenariats",
    resellerMessageLabel: "Besoins professionnels",
    resellerSubmit: "Envoyer la candidature revendeur",
    resellerSuccess: "Votre candidature revendeur a été envoyée.",
    cobrandingSeoTitle: "Demande de co-branding LUKKEY | Collaboration de marque",
    cobrandingSeoDescription: "Démarrez une demande de collaboration co-brandée avec LUKKEY.",
    cobrandingBadge: "Collaboration de marque",
    cobrandingTitle: "Lancez une discussion co-branding.",
    cobrandingSubtitle: "Un formulaire B2B ciblé pour campagnes, produits et lancements.",
    cobrandingPoint1: "Contexte marque, campagne et lancement",
    cobrandingPoint2: "Exigences design ou produit",
    cobrandingPoint3: "Analyse par l'équipe partenariats LUKKEY",
    cobrandingMessageLabel: "Brief de collaboration",
    cobrandingSubmit: "Envoyer la demande co-branding",
    cobrandingSuccess: "Votre demande co-branding a été envoyée.",
    formName: "Nom",
    formEmail: "E-mail",
    formCompany: "Entreprise / canal",
    formWebsite: "Site web ou lien social",
    formChannel: "Canal principal ou lien social",
    formAudience: "Audience ou communauté",
    formRegion: "Région de vente",
    formVolume: "Volume mensuel attendu",
    formTimeline: "Date de lancement cible",
    formSubmitting: "Envoi",
    validationRequired: "Ce champ est obligatoire.",
    validationEmail: "Saisissez une adresse e-mail valide.",
    error: "Erreur lors de l'envoi de votre demande.",
    prefillAffiliate: "Je souhaite postuler au programme d'affiliation LUKKEY.\n\nCanal / audience :\nRégion :\nFormat de collaboration souhaité :\nLiens pertinents :",
    prefillReseller: "Je souhaite postuler au programme revendeur LUKKEY.\n\nEntreprise / boutique :\nCanaux de vente :\nRégion :\nVolume mensuel attendu :\nLiens pertinents :",
    prefillCobranding: "Je souhaite discuter d'une collaboration co-branding avec LUKKEY.\n\nMarque / projet :\nIdée de campagne :\nDate de lancement cible :\nBesoins design ou produit :\nLiens pertinents :",
  }),
  es: buildPartnerInquiryTranslations({
    programAffiliate: "Afiliado",
    programReseller: "Distribuidor",
    programCobranding: "Co-branding",
    affiliateSeoTitle: "Solicitud de afiliado LUKKEY | Programa para creadores",
    affiliateSeoDescription: "Solicita unirte a LUKKEY como creador o socio afiliado.",
    affiliateBadge: "Afiliado creador",
    affiliateTitle: "Únete a LUKKEY como socio creador.",
    affiliateSubtitle: "Una solicitud rápida y cercana para creadores, reviewers, educadores y comunidades.",
    affiliatePoint1: "Solicitud simple para creadores",
    affiliatePoint2: "Comparte tu canal y encaje de audiencia",
    affiliatePoint3: "El equipo de LUKKEY responderá por email",
    affiliateMessageLabel: "Cuéntanos sobre tu contenido",
    affiliateSubmit: "Solicitar como socio creador",
    affiliateSuccess: "Tu solicitud de socio creador ha sido enviada.",
    resellerSeoTitle: "Solicitud de distribuidor LUKKEY | Alianza comercial",
    resellerSeoDescription: "Solicita convertirte en distribuidor o canal de ventas de LUKKEY.",
    resellerBadge: "Solicitud de distribuidor",
    resellerTitle: "Solicita convertirte en distribuidor LUKKEY.",
    resellerSubtitle: "Un formulario B2B conciso para tiendas, distribuidores y canales de venta.",
    resellerPoint1: "Perfil de empresa y región de ventas",
    resellerPoint2: "Encaje del canal y volumen esperado",
    resellerPoint3: "Seguimiento profesional del equipo comercial",
    resellerMessageLabel: "Requisitos comerciales",
    resellerSubmit: "Enviar solicitud de distribuidor",
    resellerSuccess: "Tu solicitud de distribuidor ha sido enviada.",
    cobrandingSeoTitle: "Consulta de co-branding LUKKEY | Colaboración de marca",
    cobrandingSeoDescription: "Inicia una consulta de colaboración co-branding con LUKKEY.",
    cobrandingBadge: "Colaboración de marca",
    cobrandingTitle: "Inicia una conversación de co-branding.",
    cobrandingSubtitle: "Un formulario B2B enfocado para campañas, productos y lanzamientos.",
    cobrandingPoint1: "Contexto de marca, campaña y lanzamiento",
    cobrandingPoint2: "Requisitos de diseño o producto",
    cobrandingPoint3: "Revisión por el equipo de alianzas de LUKKEY",
    cobrandingMessageLabel: "Brief de colaboración",
    cobrandingSubmit: "Enviar consulta de co-branding",
    cobrandingSuccess: "Tu consulta de co-branding ha sido enviada.",
    formName: "Nombre",
    formEmail: "Email",
    formCompany: "Empresa / canal",
    formWebsite: "Sitio web o enlace social",
    formChannel: "Canal principal o enlace social",
    formAudience: "Audiencia o comunidad",
    formRegion: "Región de ventas",
    formVolume: "Volumen mensual esperado",
    formTimeline: "Fecha objetivo de lanzamiento",
    formSubmitting: "Enviando",
    validationRequired: "Este campo es obligatorio.",
    validationEmail: "Introduce una dirección de email válida.",
    error: "Hubo un error al enviar tu solicitud.",
    prefillAffiliate: "Quiero postular al programa de afiliados de LUKKEY.\n\nCanal / audiencia:\nRegión:\nFormato de colaboración esperado:\nEnlaces relevantes:",
    prefillReseller: "Quiero postular al programa de distribuidores de LUKKEY.\n\nEmpresa / tienda:\nCanales de venta:\nRegión:\nVolumen mensual esperado:\nEnlaces relevantes:",
    prefillCobranding: "Quiero hablar sobre una colaboración co-branding con LUKKEY.\n\nMarca / proyecto:\nIdea de campaña:\nFecha objetivo de lanzamiento:\nRequisitos de diseño o producto:\nEnlaces relevantes:",
  }),
  ar: buildPartnerInquiryTranslations({
    programAffiliate: "الشراكة بالعمولة",
    programReseller: "موزع",
    programCobranding: "تعاون مشترك للعلامة",
    affiliateSeoTitle: "طلب شراكة بالعمولة من LUKKEY | برنامج صناع المحتوى",
    affiliateSeoDescription: "قدّم للانضمام إلى LUKKEY كصانع محتوى أو شريك بالعمولة.",
    affiliateBadge: "شراكة صناع المحتوى",
    affiliateTitle: "انضم إلى LUKKEY كشريك محتوى.",
    affiliateSubtitle: "طلب سريع وودود لصناع المحتوى والمراجعين والمعلمين وبناة المجتمعات.",
    affiliatePoint1: "طلب بسيط يناسب صناع المحتوى",
    affiliatePoint2: "شارك قناتك ومدى ملاءمة جمهورك",
    affiliatePoint3: "سيتابع معك فريق LUKKEY عبر البريد",
    affiliateMessageLabel: "أخبرنا عن محتواك",
    affiliateSubmit: "التقديم كشريك محتوى",
    affiliateSuccess: "تم إرسال طلب شراكة المحتوى.",
    resellerSeoTitle: "طلب موزع LUKKEY | شراكة تجارية",
    resellerSeoDescription: "قدّم لتصبح موزعا أو شريك قناة مبيعات لدى LUKKEY.",
    resellerBadge: "طلب موزع",
    resellerTitle: "قدّم لتصبح موزع LUKKEY.",
    resellerSubtitle: "نموذج تجاري موجز للمتاجر والموزعين وقنوات البيع.",
    resellerPoint1: "ملف الشركة ومنطقة البيع",
    resellerPoint2: "ملاءمة القناة والحجم المتوقع",
    resellerPoint3: "متابعة احترافية من فريق الشراكات",
    resellerMessageLabel: "المتطلبات التجارية",
    resellerSubmit: "إرسال طلب الموزع",
    resellerSuccess: "تم إرسال طلب الموزع.",
    cobrandingSeoTitle: "استفسار تعاون علامة LUKKEY | تعاون تجاري",
    cobrandingSeoDescription: "ابدأ استفسارا لتعاون علامة مشتركة مع LUKKEY.",
    cobrandingBadge: "تعاون العلامة",
    cobrandingTitle: "ابدأ حوارا حول التعاون المشترك.",
    cobrandingSubtitle: "نموذج تجاري مركز للحملات والمنتجات والإطلاقات.",
    cobrandingPoint1: "سياق العلامة والحملة والإطلاق",
    cobrandingPoint2: "متطلبات التصميم أو المنتج",
    cobrandingPoint3: "يراجعه فريق شراكات LUKKEY",
    cobrandingMessageLabel: "ملخص التعاون",
    cobrandingSubmit: "إرسال استفسار التعاون",
    cobrandingSuccess: "تم إرسال استفسار التعاون.",
    formName: "الاسم",
    formEmail: "البريد الإلكتروني",
    formCompany: "الشركة / القناة",
    formWebsite: "الموقع أو رابط اجتماعي",
    formChannel: "القناة الرئيسية أو الرابط الاجتماعي",
    formAudience: "الجمهور أو المجتمع",
    formRegion: "منطقة البيع",
    formVolume: "الحجم الشهري المتوقع",
    formTimeline: "موعد الإطلاق المستهدف",
    formSubmitting: "جار الإرسال",
    validationRequired: "هذا الحقل مطلوب.",
    validationEmail: "أدخل بريدا إلكترونيا صالحا.",
    error: "حدث خطأ أثناء إرسال الطلب.",
    prefillAffiliate: "أرغب في التقديم لبرنامج الشراكة بالعمولة من LUKKEY.\n\nالقناة / الجمهور:\nالمنطقة:\nصيغة التعاون المتوقعة:\nروابط ذات صلة:",
    prefillReseller: "أرغب في التقديم لبرنامج موزعي LUKKEY.\n\nالشركة / المتجر:\nقنوات البيع:\nالمنطقة:\nالحجم الشهري المتوقع:\nروابط ذات صلة:",
    prefillCobranding: "أرغب في مناقشة تعاون علامة مشتركة مع LUKKEY.\n\nالعلامة / المشروع:\nفكرة الحملة:\nموعد الإطلاق المستهدف:\nمتطلبات التصميم أو المنتج:\nروابط ذات صلة:",
  }),
  ja: buildPartnerInquiryTranslations({
    programAffiliate: "アフィリエイト",
    programReseller: "販売代理店",
    programCobranding: "共同ブランド",
    affiliateSeoTitle: "LUKKEY アフィリエイト申請 | クリエイタープログラム",
    affiliateSeoDescription: "クリエイターまたはアフィリエイトパートナーとして LUKKEY に申請します。",
    affiliateBadge: "クリエイターアフィリエイト",
    affiliateTitle: "LUKKEY のクリエイターパートナーになる。",
    affiliateSubtitle: "クリエイター、レビュー担当者、教育者、コミュニティ向けの簡潔で親しみやすい申請です。",
    affiliatePoint1: "クリエイター向けの簡単な申請",
    affiliatePoint2: "チャンネルとオーディエンスを共有",
    affiliatePoint3: "LUKKEY チームがメールで連絡",
    affiliateMessageLabel: "コンテンツについて教えてください",
    affiliateSubmit: "クリエイターパートナーとして申請",
    affiliateSuccess: "クリエイターパートナー申請を送信しました。",
    resellerSeoTitle: "LUKKEY 販売代理店申請 | ビジネスパートナーシップ",
    resellerSeoDescription: "LUKKEY の販売代理店または販売チャネルパートナーに申請します。",
    resellerBadge: "販売代理店申請",
    resellerTitle: "LUKKEY 販売代理店に申請する。",
    resellerSubtitle: "店舗、流通業者、販売チャネル向けの簡潔な B2B 受付です。",
    resellerPoint1: "会社情報と販売地域",
    resellerPoint2: "チャネル適合性と想定数量",
    resellerPoint3: "パートナー営業チームが専門的に対応",
    resellerMessageLabel: "ビジネス要件",
    resellerSubmit: "販売代理店申請を送信",
    resellerSuccess: "販売代理店申請を送信しました。",
    cobrandingSeoTitle: "LUKKEY 共同ブランド相談 | ブランド協業",
    cobrandingSeoDescription: "LUKKEY との共同ブランド協業の相談を開始します。",
    cobrandingBadge: "ブランド協業",
    cobrandingTitle: "共同ブランドの相談を始める。",
    cobrandingSubtitle: "キャンペーン、製品、ローンチ協業向けの集中した B2B 受付です。",
    cobrandingPoint1: "ブランド、キャンペーン、ローンチ背景",
    cobrandingPoint2: "デザインまたは製品要件",
    cobrandingPoint3: "LUKKEY パートナーチームが確認",
    cobrandingMessageLabel: "協業ブリーフ",
    cobrandingSubmit: "共同ブランド相談を送信",
    cobrandingSuccess: "共同ブランド相談を送信しました。",
    formName: "名前",
    formEmail: "メール",
    formCompany: "会社 / チャンネル",
    formWebsite: "WebサイトまたはSNSリンク",
    formChannel: "主なチャンネルまたはSNSリンク",
    formAudience: "オーディエンスまたはコミュニティ",
    formRegion: "販売地域",
    formVolume: "想定月間数量",
    formTimeline: "目標ローンチ時期",
    formSubmitting: "送信中",
    validationRequired: "この項目は必須です。",
    validationEmail: "有効なメールアドレスを入力してください。",
    error: "送信中にエラーが発生しました。",
    prefillAffiliate: "LUKKEY アフィリエイトプログラムに申請したいです。\n\nチャンネル / オーディエンス:\n地域:\n希望する協業形式:\n関連リンク:",
    prefillReseller: "LUKKEY 販売代理店プログラムに申請したいです。\n\n会社 / 店舗名:\n販売チャネル:\n地域:\n想定月間数量:\n関連リンク:",
    prefillCobranding: "LUKKEY との共同ブランド協業について相談したいです。\n\nブランド / プロジェクト:\nキャンペーン案:\n目標ローンチ時期:\nデザインまたは製品要件:\n関連リンク:",
  }),
  ru: buildPartnerInquiryTranslations({
    programAffiliate: "Партнерская программа",
    programReseller: "Реселлер",
    programCobranding: "Кобрендинг",
    affiliateSeoTitle: "Заявка партнера LUKKEY | Программа для авторов",
    affiliateSeoDescription: "Подайте заявку, чтобы стать автором или партнером LUKKEY.",
    affiliateBadge: "Автор-партнер",
    affiliateTitle: "Станьте автором-партнером LUKKEY.",
    affiliateSubtitle: "Быстрая и дружелюбная заявка для авторов, обозревателей, преподавателей и сообществ.",
    affiliatePoint1: "Простая заявка для авторов",
    affiliatePoint2: "Расскажите о канале и аудитории",
    affiliatePoint3: "Команда LUKKEY свяжется по email",
    affiliateMessageLabel: "Расскажите о вашем контенте",
    affiliateSubmit: "Подать заявку автора",
    affiliateSuccess: "Заявка автора отправлена.",
    resellerSeoTitle: "Заявка реселлера LUKKEY | Бизнес-партнерство",
    resellerSeoDescription: "Подайте заявку, чтобы стать реселлером или каналом продаж LUKKEY.",
    resellerBadge: "Заявка реселлера",
    resellerTitle: "Подайте заявку на статус реселлера LUKKEY.",
    resellerSubtitle: "Краткая B2B-форма для магазинов, дистрибьюторов и каналов продаж.",
    resellerPoint1: "Профиль компании и регион продаж",
    resellerPoint2: "Соответствие канала и ожидаемый объем",
    resellerPoint3: "Профессиональное сопровождение отдела партнерств",
    resellerMessageLabel: "Бизнес-требования",
    resellerSubmit: "Отправить заявку реселлера",
    resellerSuccess: "Заявка реселлера отправлена.",
    cobrandingSeoTitle: "Запрос на кобрендинг LUKKEY | Бренд-коллаборация",
    cobrandingSeoDescription: "Начните запрос на кобрендинговую коллаборацию с LUKKEY.",
    cobrandingBadge: "Бренд-коллаборация",
    cobrandingTitle: "Начните разговор о кобрендинге.",
    cobrandingSubtitle: "Фокусная B2B-форма для кампаний, продуктов и запусков.",
    cobrandingPoint1: "Контекст бренда, кампании и запуска",
    cobrandingPoint2: "Требования к дизайну или продукту",
    cobrandingPoint3: "Проверка командой партнерств LUKKEY",
    cobrandingMessageLabel: "Бриф коллаборации",
    cobrandingSubmit: "Отправить запрос на кобрендинг",
    cobrandingSuccess: "Запрос на кобрендинг отправлен.",
    formName: "Имя",
    formEmail: "Email",
    formCompany: "Компания / канал",
    formWebsite: "Сайт или социальная ссылка",
    formChannel: "Основной канал или социальная ссылка",
    formAudience: "Аудитория или сообщество",
    formRegion: "Регион продаж",
    formVolume: "Ожидаемый месячный объем",
    formTimeline: "Целевой срок запуска",
    formSubmitting: "Отправка",
    validationRequired: "Это поле обязательно.",
    validationEmail: "Введите действительный email.",
    error: "Не удалось отправить запрос.",
    prefillAffiliate: "Я хочу подать заявку на партнерскую программу LUKKEY.\n\nКанал / аудитория:\nРегион:\nОжидаемый формат сотрудничества:\nРелевантные ссылки:",
    prefillReseller: "Я хочу подать заявку на программу реселлеров LUKKEY.\n\nКомпания / магазин:\nКаналы продаж:\nРегион:\nОжидаемый месячный объем:\nРелевантные ссылки:",
    prefillCobranding: "Я хочу обсудить кобрендинговую коллаборацию с LUKKEY.\n\nБренд / проект:\nИдея кампании:\nЦелевой срок запуска:\nТребования к дизайну или продукту:\nРелевантные ссылки:",
  }),
  ko: buildPartnerInquiryTranslations({
    programAffiliate: "제휴",
    programReseller: "리셀러",
    programCobranding: "공동 브랜딩",
    affiliateSeoTitle: "LUKKEY 제휴 신청 | 크리에이터 프로그램",
    affiliateSeoDescription: "크리에이터 또는 제휴 파트너로 LUKKEY에 신청하세요.",
    affiliateBadge: "크리에이터 제휴",
    affiliateTitle: "LUKKEY 크리에이터 파트너가 되세요.",
    affiliateSubtitle: "크리에이터, 리뷰어, 교육자, 커뮤니티 운영자를 위한 간단하고 친근한 신청입니다.",
    affiliatePoint1: "크리에이터 친화적인 간단한 신청",
    affiliatePoint2: "채널과 오디언스 적합도 공유",
    affiliatePoint3: "LUKKEY 팀이 이메일로 후속 연락",
    affiliateMessageLabel: "콘텐츠를 소개해 주세요",
    affiliateSubmit: "크리에이터 파트너 신청",
    affiliateSuccess: "크리에이터 파트너 신청이 전송되었습니다.",
    resellerSeoTitle: "LUKKEY 리셀러 신청 | 비즈니스 파트너십",
    resellerSeoDescription: "LUKKEY 리셀러 또는 판매 채널 파트너로 신청하세요.",
    resellerBadge: "리셀러 신청",
    resellerTitle: "LUKKEY 리셀러가 되기 위해 신청하세요.",
    resellerSubtitle: "매장, 유통사, 판매 채널을 위한 간결한 B2B 접수입니다.",
    resellerPoint1: "회사 프로필과 판매 지역",
    resellerPoint2: "채널 적합도와 예상 물량",
    resellerPoint3: "파트너십 영업팀의 전문 후속 연락",
    resellerMessageLabel: "비즈니스 요구사항",
    resellerSubmit: "리셀러 신청 제출",
    resellerSuccess: "리셀러 신청이 전송되었습니다.",
    cobrandingSeoTitle: "LUKKEY 공동 브랜딩 문의 | 브랜드 협업",
    cobrandingSeoDescription: "LUKKEY와 공동 브랜딩 협업 문의를 시작하세요.",
    cobrandingBadge: "브랜드 협업",
    cobrandingTitle: "공동 브랜딩 논의를 시작하세요.",
    cobrandingSubtitle: "캠페인, 제품, 출시 협업을 위한 집중형 B2B 접수입니다.",
    cobrandingPoint1: "브랜드, 캠페인, 출시 맥락",
    cobrandingPoint2: "디자인 또는 제품 요구사항",
    cobrandingPoint3: "LUKKEY 파트너십 팀 검토",
    cobrandingMessageLabel: "협업 브리프",
    cobrandingSubmit: "공동 브랜딩 문의 제출",
    cobrandingSuccess: "공동 브랜딩 문의가 전송되었습니다.",
    formName: "이름",
    formEmail: "이메일",
    formCompany: "회사 / 채널",
    formWebsite: "웹사이트 또는 소셜 링크",
    formChannel: "주요 채널 또는 소셜 링크",
    formAudience: "오디언스 또는 커뮤니티",
    formRegion: "판매 지역",
    formVolume: "예상 월간 물량",
    formTimeline: "목표 출시 시점",
    formSubmitting: "제출 중",
    validationRequired: "필수 항목입니다.",
    validationEmail: "유효한 이메일 주소를 입력하세요.",
    error: "문의 제출 중 오류가 발생했습니다.",
    prefillAffiliate: "LUKKEY 제휴 프로그램에 신청하고 싶습니다.\n\n채널 / 오디언스:\n지역:\n희망 협업 방식:\n관련 링크:",
    prefillReseller: "LUKKEY 리셀러 프로그램에 신청하고 싶습니다.\n\n회사 / 매장명:\n판매 채널:\n지역:\n예상 월간 물량:\n관련 링크:",
    prefillCobranding: "LUKKEY와 공동 브랜딩 협업을 논의하고 싶습니다.\n\n브랜드 / 프로젝트:\n캠페인 아이디어:\n목표 출시 시점:\n디자인 또는 제품 요구사항:\n관련 링크:",
  }),
  pt: buildPartnerInquiryTranslations({
    programAffiliate: "Afiliado",
    programReseller: "Revendedor",
    programCobranding: "Co-branding",
    affiliateSeoTitle: "Candidatura de afiliado LUKKEY | Programa de criadores",
    affiliateSeoDescription: "Candidate-se para participar da LUKKEY como criador ou parceiro afiliado.",
    affiliateBadge: "Afiliado criador",
    affiliateTitle: "Junte-se à LUKKEY como parceiro criador.",
    affiliateSubtitle: "Uma candidatura rápida e amigável para criadores, reviewers, educadores e comunidades.",
    affiliatePoint1: "Candidatura simples para criadores",
    affiliatePoint2: "Partilhe o seu canal e audiência",
    affiliatePoint3: "A equipa LUKKEY fará o seguimento por email",
    affiliateMessageLabel: "Conte-nos sobre o seu conteúdo",
    affiliateSubmit: "Candidatar-se como criador",
    affiliateSuccess: "A sua candidatura de criador foi enviada.",
    resellerSeoTitle: "Candidatura de revendedor LUKKEY | Parceria comercial",
    resellerSeoDescription: "Candidate-se para ser revendedor ou parceiro de canal LUKKEY.",
    resellerBadge: "Candidatura de revendedor",
    resellerTitle: "Candidate-se para ser revendedor LUKKEY.",
    resellerSubtitle: "Um formulário B2B conciso para lojas, distribuidores e canais de venda.",
    resellerPoint1: "Perfil da empresa e região de venda",
    resellerPoint2: "Adequação do canal e volume esperado",
    resellerPoint3: "Seguimento profissional pela equipa de parcerias",
    resellerMessageLabel: "Requisitos comerciais",
    resellerSubmit: "Enviar candidatura de revendedor",
    resellerSuccess: "A sua candidatura de revendedor foi enviada.",
    cobrandingSeoTitle: "Consulta de co-branding LUKKEY | Colaboração de marca",
    cobrandingSeoDescription: "Inicie uma consulta de colaboração co-branded com a LUKKEY.",
    cobrandingBadge: "Colaboração de marca",
    cobrandingTitle: "Inicie uma conversa de co-branding.",
    cobrandingSubtitle: "Um formulário B2B focado para campanhas, produtos e lançamentos.",
    cobrandingPoint1: "Contexto de marca, campanha e lançamento",
    cobrandingPoint2: "Requisitos de design ou produto",
    cobrandingPoint3: "Revisão pela equipa de parcerias LUKKEY",
    cobrandingMessageLabel: "Brief de colaboração",
    cobrandingSubmit: "Enviar consulta de co-branding",
    cobrandingSuccess: "A sua consulta de co-branding foi enviada.",
    formName: "Nome",
    formEmail: "Email",
    formCompany: "Empresa / canal",
    formWebsite: "Site ou link social",
    formChannel: "Canal principal ou link social",
    formAudience: "Audiência ou comunidade",
    formRegion: "Região de venda",
    formVolume: "Volume mensal esperado",
    formTimeline: "Data alvo de lançamento",
    formSubmitting: "A enviar",
    validationRequired: "Este campo é obrigatório.",
    validationEmail: "Introduza um endereço de email válido.",
    error: "Ocorreu um erro ao enviar a sua consulta.",
    prefillAffiliate: "Gostaria de me candidatar ao programa de afiliados LUKKEY.\n\nCanal / audiência:\nRegião:\nFormato de colaboração esperado:\nLinks relevantes:",
    prefillReseller: "Gostaria de me candidatar ao programa de revendedores LUKKEY.\n\nEmpresa / loja:\nCanais de venda:\nRegião:\nVolume mensal esperado:\nLinks relevantes:",
    prefillCobranding: "Gostaria de discutir uma colaboração co-branding com a LUKKEY.\n\nMarca / projeto:\nIdeia de campanha:\nData alvo de lançamento:\nRequisitos de design ou produto:\nLinks relevantes:",
  }),
  it: buildPartnerInquiryTranslations({
    programAffiliate: "Affiliato",
    programReseller: "Rivenditore",
    programCobranding: "Co-branding",
    affiliateSeoTitle: "Candidatura affiliato LUKKEY | Programma creator",
    affiliateSeoDescription: "Candidati per entrare in LUKKEY come creator o partner affiliato.",
    affiliateBadge: "Creator affiliato",
    affiliateTitle: "Diventa creator partner LUKKEY.",
    affiliateSubtitle: "Una candidatura rapida e amichevole per creator, reviewer, educator e community.",
    affiliatePoint1: "Candidatura semplice per creator",
    affiliatePoint2: "Condividi canale e pubblico",
    affiliatePoint3: "Il team LUKKEY ti ricontatterà via email",
    affiliateMessageLabel: "Raccontaci i tuoi contenuti",
    affiliateSubmit: "Candidati come creator partner",
    affiliateSuccess: "La tua candidatura creator è stata inviata.",
    resellerSeoTitle: "Candidatura rivenditore LUKKEY | Partnership B2B",
    resellerSeoDescription: "Candidati per diventare rivenditore o canale di vendita LUKKEY.",
    resellerBadge: "Candidatura rivenditore",
    resellerTitle: "Candidati per diventare rivenditore LUKKEY.",
    resellerSubtitle: "Un modulo B2B conciso per negozi, distributori e canali di vendita.",
    resellerPoint1: "Profilo aziendale e area di vendita",
    resellerPoint2: "Compatibilità del canale e volume previsto",
    resellerPoint3: "Follow-up professionale dal team partnership",
    resellerMessageLabel: "Requisiti commerciali",
    resellerSubmit: "Invia candidatura rivenditore",
    resellerSuccess: "La tua candidatura rivenditore è stata inviata.",
    cobrandingSeoTitle: "Richiesta co-branding LUKKEY | Collaborazione brand",
    cobrandingSeoDescription: "Avvia una richiesta di collaborazione co-branding con LUKKEY.",
    cobrandingBadge: "Collaborazione brand",
    cobrandingTitle: "Avvia una conversazione co-branding.",
    cobrandingSubtitle: "Un modulo B2B mirato per campagne, prodotti e lanci.",
    cobrandingPoint1: "Contesto brand, campagna e lancio",
    cobrandingPoint2: "Requisiti di design o prodotto",
    cobrandingPoint3: "Revisione dal team partnership LUKKEY",
    cobrandingMessageLabel: "Brief di collaborazione",
    cobrandingSubmit: "Invia richiesta co-branding",
    cobrandingSuccess: "La tua richiesta co-branding è stata inviata.",
    formName: "Nome",
    formEmail: "Email",
    formCompany: "Azienda / canale",
    formWebsite: "Sito web o link social",
    formChannel: "Canale principale o link social",
    formAudience: "Pubblico o community",
    formRegion: "Area di vendita",
    formVolume: "Volume mensile previsto",
    formTimeline: "Tempistica di lancio",
    formSubmitting: "Invio",
    validationRequired: "Questo campo è obbligatorio.",
    validationEmail: "Inserisci un indirizzo email valido.",
    error: "Si è verificato un errore durante l'invio.",
    prefillAffiliate: "Vorrei candidarmi al programma affiliati LUKKEY.\n\nCanale / pubblico:\nArea:\nFormato di collaborazione previsto:\nLink rilevanti:",
    prefillReseller: "Vorrei candidarmi al programma rivenditori LUKKEY.\n\nAzienda / negozio:\nCanali di vendita:\nArea:\nVolume mensile previsto:\nLink rilevanti:",
    prefillCobranding: "Vorrei discutere una collaborazione co-branding con LUKKEY.\n\nBrand / progetto:\nIdea campagna:\nTempistica di lancio:\nRequisiti design o prodotto:\nLink rilevanti:",
  }),
  de: buildPartnerInquiryTranslations({
    programAffiliate: "Affiliate",
    programReseller: "Reseller",
    programCobranding: "Co-Branding",
    affiliateSeoTitle: "LUKKEY Affiliate-Bewerbung | Creator-Programm",
    affiliateSeoDescription: "Bewirb dich als Creator oder Affiliate-Partner bei LUKKEY.",
    affiliateBadge: "Creator Affiliate",
    affiliateTitle: "Werde Creator-Partner von LUKKEY.",
    affiliateSubtitle: "Eine schnelle, freundliche Bewerbung für Creator, Reviewer, Educators und Communities.",
    affiliatePoint1: "Einfache Bewerbung für Creator",
    affiliatePoint2: "Teile Kanal und Zielgruppe",
    affiliatePoint3: "Das LUKKEY Team meldet sich per E-Mail",
    affiliateMessageLabel: "Erzähle uns von deinem Content",
    affiliateSubmit: "Als Creator-Partner bewerben",
    affiliateSuccess: "Deine Creator-Bewerbung wurde gesendet.",
    resellerSeoTitle: "LUKKEY Reseller-Bewerbung | Geschäftspartnerschaft",
    resellerSeoDescription: "Bewirb dich als LUKKEY Reseller oder Vertriebspartner.",
    resellerBadge: "Reseller-Bewerbung",
    resellerTitle: "Bewirb dich als LUKKEY Reseller.",
    resellerSubtitle: "Ein kompaktes B2B-Formular für Shops, Distributoren und Vertriebskanäle.",
    resellerPoint1: "Unternehmensprofil und Vertriebsregion",
    resellerPoint2: "Kanal-Fit und erwartetes Volumen",
    resellerPoint3: "Professionelle Nachverfolgung durch das Partnerteam",
    resellerMessageLabel: "Geschäftliche Anforderungen",
    resellerSubmit: "Reseller-Bewerbung senden",
    resellerSuccess: "Deine Reseller-Bewerbung wurde gesendet.",
    cobrandingSeoTitle: "LUKKEY Co-Branding Anfrage | Markenkooperation",
    cobrandingSeoDescription: "Starte eine Co-Branding Anfrage mit LUKKEY.",
    cobrandingBadge: "Markenkooperation",
    cobrandingTitle: "Starte ein Co-Branding Gespräch.",
    cobrandingSubtitle: "Ein fokussiertes B2B-Formular für Kampagnen, Produkte und Launches.",
    cobrandingPoint1: "Kontext zu Marke, Kampagne und Launch",
    cobrandingPoint2: "Design- oder Produktanforderungen",
    cobrandingPoint3: "Prüfung durch das LUKKEY Partnerteam",
    cobrandingMessageLabel: "Kooperationsbriefing",
    cobrandingSubmit: "Co-Branding Anfrage senden",
    cobrandingSuccess: "Deine Co-Branding Anfrage wurde gesendet.",
    formName: "Name",
    formEmail: "E-Mail",
    formCompany: "Unternehmen / Kanal",
    formWebsite: "Website oder Social Link",
    formChannel: "Hauptkanal oder Social Link",
    formAudience: "Zielgruppe oder Community",
    formRegion: "Vertriebsregion",
    formVolume: "Erwartetes Monatsvolumen",
    formTimeline: "Geplanter Launch-Zeitpunkt",
    formSubmitting: "Wird gesendet",
    validationRequired: "Dieses Feld ist erforderlich.",
    validationEmail: "Gib eine gültige E-Mail-Adresse ein.",
    error: "Beim Senden deiner Anfrage ist ein Fehler aufgetreten.",
    prefillAffiliate: "Ich möchte mich für das LUKKEY Affiliate-Programm bewerben.\n\nKanal / Zielgruppe:\nRegion:\nGewünschtes Kooperationsformat:\nRelevante Links:",
    prefillReseller: "Ich möchte mich für das LUKKEY Reseller-Programm bewerben.\n\nUnternehmen / Shop:\nVertriebskanäle:\nRegion:\nErwartetes Monatsvolumen:\nRelevante Links:",
    prefillCobranding: "Ich möchte eine Co-Branding Kooperation mit LUKKEY besprechen.\n\nMarke / Projekt:\nKampagnenidee:\nGeplanter Launch-Zeitpunkt:\nDesign- oder Produktanforderungen:\nRelevante Links:",
  }),
  hi: buildPartnerInquiryTranslations({
    programAffiliate: "एफिलिएट",
    programReseller: "रीसेलर",
    programCobranding: "को-ब्रांडिंग",
    affiliateSeoTitle: "LUKKEY एफिलिएट आवेदन | क्रिएटर प्रोग्राम",
    affiliateSeoDescription: "LUKKEY में क्रिएटर या एफिलिएट पार्टनर के रूप में आवेदन करें।",
    affiliateBadge: "क्रिएटर एफिलिएट",
    affiliateTitle: "LUKKEY के क्रिएटर पार्टनर बनें।",
    affiliateSubtitle: "क्रिएटर्स, रिव्यूअर्स, एजुकेटर्स और कम्युनिटी बिल्डर्स के लिए तेज और सरल आवेदन।",
    affiliatePoint1: "क्रिएटर-फ्रेंडली सरल आवेदन",
    affiliatePoint2: "अपना चैनल और ऑडियंस फिट साझा करें",
    affiliatePoint3: "LUKKEY टीम ईमेल से संपर्क करेगी",
    affiliateMessageLabel: "अपने कंटेंट के बारे में बताएं",
    affiliateSubmit: "क्रिएटर पार्टनर के रूप में आवेदन करें",
    affiliateSuccess: "आपका क्रिएटर पार्टनर आवेदन भेज दिया गया है।",
    resellerSeoTitle: "LUKKEY रीसेलर आवेदन | बिजनेस पार्टनरशिप",
    resellerSeoDescription: "LUKKEY रीसेलर या सेल्स चैनल पार्टनर बनने के लिए आवेदन करें।",
    resellerBadge: "रीसेलर आवेदन",
    resellerTitle: "LUKKEY रीसेलर बनने के लिए आवेदन करें।",
    resellerSubtitle: "दुकानों, वितरकों और सेल्स चैनलों के लिए संक्षिप्त B2B फॉर्म।",
    resellerPoint1: "कंपनी प्रोफाइल और बिक्री क्षेत्र",
    resellerPoint2: "चैनल फिट और अपेक्षित मात्रा",
    resellerPoint3: "पार्टनरशिप सेल्स टीम से प्रोफेशनल फॉलो-अप",
    resellerMessageLabel: "व्यावसायिक आवश्यकताएं",
    resellerSubmit: "रीसेलर आवेदन भेजें",
    resellerSuccess: "आपका रीसेलर आवेदन भेज दिया गया है।",
    cobrandingSeoTitle: "LUKKEY को-ब्रांडिंग पूछताछ | ब्रांड सहयोग",
    cobrandingSeoDescription: "LUKKEY के साथ को-ब्रांडिंग सहयोग पूछताछ शुरू करें।",
    cobrandingBadge: "ब्रांड सहयोग",
    cobrandingTitle: "को-ब्रांडिंग बातचीत शुरू करें।",
    cobrandingSubtitle: "कैंपेन, प्रोडक्ट और लॉन्च सहयोग के लिए केंद्रित B2B फॉर्म।",
    cobrandingPoint1: "ब्रांड, कैंपेन और लॉन्च संदर्भ",
    cobrandingPoint2: "डिजाइन या प्रोडक्ट आवश्यकताएं",
    cobrandingPoint3: "LUKKEY पार्टनरशिप टीम द्वारा समीक्षा",
    cobrandingMessageLabel: "सहयोग ब्रीफ",
    cobrandingSubmit: "को-ब्रांडिंग पूछताछ भेजें",
    cobrandingSuccess: "आपकी को-ब्रांडिंग पूछताछ भेज दी गई है।",
    formName: "नाम",
    formEmail: "ईमेल",
    formCompany: "कंपनी / चैनल",
    formWebsite: "वेबसाइट या सोशल लिंक",
    formChannel: "मुख्य चैनल या सोशल लिंक",
    formAudience: "ऑडियंस या कम्युनिटी",
    formRegion: "बिक्री क्षेत्र",
    formVolume: "अपेक्षित मासिक मात्रा",
    formTimeline: "लक्ष्य लॉन्च समय",
    formSubmitting: "भेजा जा रहा है",
    validationRequired: "यह फ़ील्ड आवश्यक है।",
    validationEmail: "मान्य ईमेल पता दर्ज करें।",
    error: "आपकी पूछताछ भेजते समय त्रुटि हुई।",
    prefillAffiliate: "मैं LUKKEY एफिलिएट प्रोग्राम के लिए आवेदन करना चाहता/चाहती हूं।\n\nचैनल / ऑडियंस:\nक्षेत्र:\nअपेक्षित सहयोग प्रारूप:\nसंबंधित लिंक:",
    prefillReseller: "मैं LUKKEY रीसेलर प्रोग्राम के लिए आवेदन करना चाहता/चाहती हूं।\n\nकंपनी / स्टोर:\nसेल्स चैनल:\nक्षेत्र:\nअपेक्षित मासिक मात्रा:\nसंबंधित लिंक:",
    prefillCobranding: "मैं LUKKEY के साथ को-ब्रांडिंग सहयोग पर चर्चा करना चाहता/चाहती हूं।\n\nब्रांड / प्रोजेक्ट:\nकैंपेन आइडिया:\nलक्ष्य लॉन्च समय:\nडिजाइन या प्रोडक्ट आवश्यकताएं:\nसंबंधित लिंक:",
  }),
  mn: buildPartnerInquiryTranslations({
    programAffiliate: "Түншлэл",
    programReseller: "Дахин борлуулагч",
    programCobranding: "Хамтарсан брэнд",
    affiliateSeoTitle: "LUKKEY түншлэлийн хүсэлт | Контент бүтээгчийн хөтөлбөр",
    affiliateSeoDescription: "LUKKEY-д контент бүтээгч эсвэл түншээр хүсэлт илгээнэ үү.",
    affiliateBadge: "Контент бүтээгчийн түншлэл",
    affiliateTitle: "LUKKEY-ийн контент бүтээгч түнш болоорой.",
    affiliateSubtitle: "Контент бүтээгч, тоймч, сургагч, community-д зориулсан энгийн хүсэлт.",
    affiliatePoint1: "Контент бүтээгчид тохирсон энгийн хүсэлт",
    affiliatePoint2: "Суваг болон үзэгчдийн тохироог хуваалцах",
    affiliatePoint3: "LUKKEY баг имэйлээр холбогдоно",
    affiliateMessageLabel: "Контентынхоо талаар бичнэ үү",
    affiliateSubmit: "Контент бүтээгч түншээр хүсэлт илгээх",
    affiliateSuccess: "Таны контент бүтээгчийн хүсэлт илгээгдлээ.",
    resellerSeoTitle: "LUKKEY дахин борлуулагчийн хүсэлт | Бизнес түншлэл",
    resellerSeoDescription: "LUKKEY дахин борлуулагч эсвэл борлуулалтын суваг болох хүсэлт илгээнэ үү.",
    resellerBadge: "Дахин борлуулагчийн хүсэлт",
    resellerTitle: "LUKKEY дахин борлуулагч болох хүсэлт илгээх.",
    resellerSubtitle: "Дэлгүүр, дистрибьютор, борлуулалтын сувгуудад зориулсан товч B2B маягт.",
    resellerPoint1: "Компанийн мэдээлэл ба борлуулалтын бүс",
    resellerPoint2: "Сувгийн тохироо ба хүлээгдэж буй хэмжээ",
    resellerPoint3: "Түншлэлийн борлуулалтын багаас мэргэжлийн хариу",
    resellerMessageLabel: "Бизнес шаардлага",
    resellerSubmit: "Дахин борлуулагчийн хүсэлт илгээх",
    resellerSuccess: "Таны дахин борлуулагчийн хүсэлт илгээгдлээ.",
    cobrandingSeoTitle: "LUKKEY хамтарсан брэндийн хүсэлт | Брэнд хамтын ажиллагаа",
    cobrandingSeoDescription: "LUKKEY-тэй хамтарсан брэндийн хүсэлт эхлүүлэх.",
    cobrandingBadge: "Брэнд хамтын ажиллагаа",
    cobrandingTitle: "Хамтарсан брэндийн яриа эхлүүлэх.",
    cobrandingSubtitle: "Кампанит ажил, бүтээгдэхүүн, нээлтэд зориулсан төвлөрсөн B2B маягт.",
    cobrandingPoint1: "Брэнд, кампанит ажил, нээлтийн нөхцөл",
    cobrandingPoint2: "Дизайн эсвэл бүтээгдэхүүний шаардлага",
    cobrandingPoint3: "LUKKEY түншлэлийн баг хянана",
    cobrandingMessageLabel: "Хамтын ажиллагааны товч",
    cobrandingSubmit: "Хамтарсан брэндийн хүсэлт илгээх",
    cobrandingSuccess: "Таны хамтарсан брэндийн хүсэлт илгээгдлээ.",
    formName: "Нэр",
    formEmail: "Имэйл",
    formCompany: "Компани / суваг",
    formWebsite: "Вэбсайт эсвэл сошиал холбоос",
    formChannel: "Үндсэн суваг эсвэл сошиал холбоос",
    formAudience: "Үзэгчид эсвэл community",
    formRegion: "Борлуулалтын бүс",
    formVolume: "Хүлээгдэж буй сарын хэмжээ",
    formTimeline: "Зорилтот нээлтийн хугацаа",
    formSubmitting: "Илгээж байна",
    validationRequired: "Энэ талбар шаардлагатай.",
    validationEmail: "Зөв имэйл хаяг оруулна уу.",
    error: "Хүсэлт илгээхэд алдаа гарлаа.",
    prefillAffiliate: "Би LUKKEY түншлэлийн хөтөлбөрт хүсэлт илгээхийг хүсэж байна.\n\nСуваг / үзэгчид:\nБүс:\nХүлээгдэж буй хамтын ажиллагааны хэлбэр:\nХолбогдох холбоосууд:",
    prefillReseller: "Би LUKKEY дахин борлуулагчийн хөтөлбөрт хүсэлт илгээхийг хүсэж байна.\n\nКомпани / дэлгүүр:\nБорлуулалтын сувгууд:\nБүс:\nХүлээгдэж буй сарын хэмжээ:\nХолбогдох холбоосууд:",
    prefillCobranding: "Би LUKKEY-тэй хамтарсан брэндийн хамтын ажиллагаа ярилцахыг хүсэж байна.\n\nБрэнд / төсөл:\nКампанит ажлын санаа:\nЗорилтот нээлтийн хугацаа:\nДизайн эсвэл бүтээгдэхүүний шаардлага:\nХолбогдох холбоосууд:",
  }),
  th: buildPartnerInquiryTranslations({
    programAffiliate: "พันธมิตรแนะนำ",
    programReseller: "ตัวแทนจำหน่าย",
    programCobranding: "โคแบรนด์",
    affiliateSeoTitle: "สมัครพันธมิตร LUKKEY | โปรแกรมครีเอเตอร์",
    affiliateSeoDescription: "สมัครเข้าร่วม LUKKEY ในฐานะครีเอเตอร์หรือพันธมิตรแนะนำ",
    affiliateBadge: "ครีเอเตอร์พันธมิตร",
    affiliateTitle: "เข้าร่วม LUKKEY ในฐานะครีเอเตอร์พันธมิตร",
    affiliateSubtitle: "แบบฟอร์มที่รวดเร็วและเป็นมิตรสำหรับครีเอเตอร์ นักรีวิว นักสอน และชุมชน",
    affiliatePoint1: "สมัครง่ายสำหรับครีเอเตอร์",
    affiliatePoint2: "แชร์ช่องทางและกลุ่มผู้ชมของคุณ",
    affiliatePoint3: "ทีม LUKKEY จะติดต่อกลับทางอีเมล",
    affiliateMessageLabel: "บอกเราเกี่ยวกับคอนเทนต์ของคุณ",
    affiliateSubmit: "สมัครเป็นครีเอเตอร์พันธมิตร",
    affiliateSuccess: "ส่งใบสมัครครีเอเตอร์พันธมิตรแล้ว",
    resellerSeoTitle: "สมัครตัวแทนจำหน่าย LUKKEY | พันธมิตรธุรกิจ",
    resellerSeoDescription: "สมัครเป็นตัวแทนจำหน่ายหรือช่องทางขายของ LUKKEY",
    resellerBadge: "สมัครตัวแทนจำหน่าย",
    resellerTitle: "สมัครเป็นตัวแทนจำหน่าย LUKKEY",
    resellerSubtitle: "แบบฟอร์ม B2B ที่กระชับสำหรับร้านค้า ผู้จัดจำหน่าย และช่องทางขาย",
    resellerPoint1: "ข้อมูลธุรกิจและพื้นที่ขาย",
    resellerPoint2: "ความเหมาะสมของช่องทางและยอดที่คาดหวัง",
    resellerPoint3: "ทีมพาร์ทเนอร์ฝ่ายขายจะติดต่อกลับอย่างมืออาชีพ",
    resellerMessageLabel: "ความต้องการทางธุรกิจ",
    resellerSubmit: "ส่งใบสมัครตัวแทนจำหน่าย",
    resellerSuccess: "ส่งใบสมัครตัวแทนจำหน่ายแล้ว",
    cobrandingSeoTitle: "สอบถามโคแบรนด์ LUKKEY | ความร่วมมือแบรนด์",
    cobrandingSeoDescription: "เริ่มสอบถามความร่วมมือโคแบรนด์กับ LUKKEY",
    cobrandingBadge: "ความร่วมมือแบรนด์",
    cobrandingTitle: "เริ่มคุยเรื่องโคแบรนด์",
    cobrandingSubtitle: "แบบฟอร์ม B2B สำหรับแคมเปญ ผลิตภัณฑ์ และการเปิดตัว",
    cobrandingPoint1: "บริบทแบรนด์ แคมเปญ และการเปิดตัว",
    cobrandingPoint2: "ข้อกำหนดด้านดีไซน์หรือผลิตภัณฑ์",
    cobrandingPoint3: "ทีมพาร์ทเนอร์ LUKKEY จะตรวจสอบ",
    cobrandingMessageLabel: "บรีฟความร่วมมือ",
    cobrandingSubmit: "ส่งคำขอโคแบรนด์",
    cobrandingSuccess: "ส่งคำขอโคแบรนด์แล้ว",
    formName: "ชื่อ",
    formEmail: "อีเมล",
    formCompany: "บริษัท / ช่องทาง",
    formWebsite: "เว็บไซต์หรือลิงก์โซเชียล",
    formChannel: "ช่องทางหลักหรือลิงก์โซเชียล",
    formAudience: "ผู้ชมหรือชุมชน",
    formRegion: "พื้นที่ขาย",
    formVolume: "ยอดต่อเดือนที่คาดหวัง",
    formTimeline: "กำหนดเปิดตัว",
    formSubmitting: "กำลังส่ง",
    validationRequired: "จำเป็นต้องกรอกช่องนี้",
    validationEmail: "กรุณากรอกอีเมลที่ถูกต้อง",
    error: "เกิดข้อผิดพลาดในการส่งคำขอ",
    prefillAffiliate: "ฉันต้องการสมัครโปรแกรมพันธมิตรแนะนำของ LUKKEY\n\nช่องทาง / ผู้ชม:\nภูมิภาค:\nรูปแบบความร่วมมือที่คาดหวัง:\nลิงก์ที่เกี่ยวข้อง:",
    prefillReseller: "ฉันต้องการสมัครโปรแกรมตัวแทนจำหน่ายของ LUKKEY\n\nบริษัท / ร้านค้า:\nช่องทางขาย:\nภูมิภาค:\nยอดต่อเดือนที่คาดหวัง:\nลิงก์ที่เกี่ยวข้อง:",
    prefillCobranding: "ฉันต้องการพูดคุยเรื่องความร่วมมือโคแบรนด์กับ LUKKEY\n\nแบรนด์ / โปรเจกต์:\nไอเดียแคมเปญ:\nกำหนดเปิดตัว:\nข้อกำหนดด้านดีไซน์หรือผลิตภัณฑ์:\nลิงก์ที่เกี่ยวข้อง:",
  }),
  uk: buildPartnerInquiryTranslations({
    programAffiliate: "Партнерська програма",
    programReseller: "Реселер",
    programCobranding: "Кобрендинг",
    affiliateSeoTitle: "Заявка партнера LUKKEY | Програма для авторів",
    affiliateSeoDescription: "Подайте заявку, щоб приєднатися до LUKKEY як автор або партнер.",
    affiliateBadge: "Автор-партнер",
    affiliateTitle: "Станьте автором-партнером LUKKEY.",
    affiliateSubtitle: "Швидка й дружня заявка для авторів, оглядачів, освітян і спільнот.",
    affiliatePoint1: "Проста заявка для авторів",
    affiliatePoint2: "Поділіться каналом і аудиторією",
    affiliatePoint3: "Команда LUKKEY зв'яжеться електронною поштою",
    affiliateMessageLabel: "Розкажіть про ваш контент",
    affiliateSubmit: "Подати заявку автора",
    affiliateSuccess: "Вашу заявку автора надіслано.",
    resellerSeoTitle: "Заявка реселера LUKKEY | Бізнес-партнерство",
    resellerSeoDescription: "Подайте заявку, щоб стати реселером або каналом продажів LUKKEY.",
    resellerBadge: "Заявка реселера",
    resellerTitle: "Подайте заявку, щоб стати реселером LUKKEY.",
    resellerSubtitle: "Стисла B2B-форма для магазинів, дистриб'юторів і каналів продажів.",
    resellerPoint1: "Профіль компанії та регіон продажів",
    resellerPoint2: "Відповідність каналу та очікуваний обсяг",
    resellerPoint3: "Професійний супровід команди партнерств",
    resellerMessageLabel: "Бізнес-вимоги",
    resellerSubmit: "Надіслати заявку реселера",
    resellerSuccess: "Вашу заявку реселера надіслано.",
    cobrandingSeoTitle: "Запит на кобрендинг LUKKEY | Бренд-співпраця",
    cobrandingSeoDescription: "Почніть запит на кобрендингову співпрацю з LUKKEY.",
    cobrandingBadge: "Бренд-співпраця",
    cobrandingTitle: "Почніть розмову про кобрендинг.",
    cobrandingSubtitle: "Фокусна B2B-форма для кампаній, продуктів і запусків.",
    cobrandingPoint1: "Контекст бренду, кампанії та запуску",
    cobrandingPoint2: "Вимоги до дизайну або продукту",
    cobrandingPoint3: "Розгляд командою партнерств LUKKEY",
    cobrandingMessageLabel: "Бриф співпраці",
    cobrandingSubmit: "Надіслати запит на кобрендинг",
    cobrandingSuccess: "Ваш запит на кобрендинг надіслано.",
    formName: "Ім'я",
    formEmail: "Email",
    formCompany: "Компанія / канал",
    formWebsite: "Сайт або соціальне посилання",
    formChannel: "Основний канал або соціальне посилання",
    formAudience: "Аудиторія або спільнота",
    formRegion: "Регіон продажів",
    formVolume: "Очікуваний місячний обсяг",
    formTimeline: "Цільова дата запуску",
    formSubmitting: "Надсилання",
    validationRequired: "Це поле обов'язкове.",
    validationEmail: "Введіть дійсну email-адресу.",
    error: "Під час надсилання запиту сталася помилка.",
    prefillAffiliate: "Я хочу подати заявку на партнерську програму LUKKEY.\n\nКанал / аудиторія:\nРегіон:\nОчікуваний формат співпраці:\nРелевантні посилання:",
    prefillReseller: "Я хочу подати заявку на програму реселерів LUKKEY.\n\nКомпанія / магазин:\nКанали продажів:\nРегіон:\nОчікуваний місячний обсяг:\nРелевантні посилання:",
    prefillCobranding: "Я хочу обговорити кобрендингову співпрацю з LUKKEY.\n\nБренд / проєкт:\nІдея кампанії:\nЦільова дата запуску:\nВимоги до дизайну або продукту:\nРелевантні посилання:",
  }),
  vi: buildPartnerInquiryTranslations({
    programAffiliate: "Affiliate",
    programReseller: "Đại lý",
    programCobranding: "Đồng thương hiệu",
    affiliateSeoTitle: "Đăng ký affiliate LUKKEY | Chương trình creator",
    affiliateSeoDescription: "Đăng ký tham gia LUKKEY với vai trò creator hoặc đối tác affiliate.",
    affiliateBadge: "Creator affiliate",
    affiliateTitle: "Trở thành creator partner của LUKKEY.",
    affiliateSubtitle: "Mẫu đăng ký nhanh, thân thiện cho creator, reviewer, educator và cộng đồng.",
    affiliatePoint1: "Đăng ký đơn giản cho creator",
    affiliatePoint2: "Chia sẻ kênh và tệp khán giả",
    affiliatePoint3: "Đội ngũ LUKKEY sẽ phản hồi qua email",
    affiliateMessageLabel: "Giới thiệu nội dung của bạn",
    affiliateSubmit: "Đăng ký làm creator partner",
    affiliateSuccess: "Đơn đăng ký creator partner đã được gửi.",
    resellerSeoTitle: "Đăng ký đại lý LUKKEY | Hợp tác kinh doanh",
    resellerSeoDescription: "Đăng ký trở thành đại lý hoặc kênh bán hàng của LUKKEY.",
    resellerBadge: "Đăng ký đại lý",
    resellerTitle: "Đăng ký trở thành đại lý LUKKEY.",
    resellerSubtitle: "Biểu mẫu B2B ngắn gọn cho cửa hàng, nhà phân phối và kênh bán hàng.",
    resellerPoint1: "Hồ sơ doanh nghiệp và khu vực bán hàng",
    resellerPoint2: "Độ phù hợp kênh và sản lượng dự kiến",
    resellerPoint3: "Theo dõi chuyên nghiệp từ đội ngũ đối tác",
    resellerMessageLabel: "Nhu cầu kinh doanh",
    resellerSubmit: "Gửi đăng ký đại lý",
    resellerSuccess: "Đơn đăng ký đại lý đã được gửi.",
    cobrandingSeoTitle: "Yêu cầu đồng thương hiệu LUKKEY | Hợp tác thương hiệu",
    cobrandingSeoDescription: "Bắt đầu yêu cầu hợp tác đồng thương hiệu với LUKKEY.",
    cobrandingBadge: "Hợp tác thương hiệu",
    cobrandingTitle: "Bắt đầu trao đổi về đồng thương hiệu.",
    cobrandingSubtitle: "Biểu mẫu B2B tập trung cho chiến dịch, sản phẩm và ra mắt.",
    cobrandingPoint1: "Bối cảnh thương hiệu, chiến dịch và ra mắt",
    cobrandingPoint2: "Yêu cầu thiết kế hoặc sản phẩm",
    cobrandingPoint3: "Đội ngũ đối tác LUKKEY sẽ xem xét",
    cobrandingMessageLabel: "Tóm tắt hợp tác",
    cobrandingSubmit: "Gửi yêu cầu đồng thương hiệu",
    cobrandingSuccess: "Yêu cầu đồng thương hiệu đã được gửi.",
    formName: "Tên",
    formEmail: "Email",
    formCompany: "Công ty / kênh",
    formWebsite: "Website hoặc liên kết mạng xã hội",
    formChannel: "Kênh chính hoặc liên kết mạng xã hội",
    formAudience: "Khán giả hoặc cộng đồng",
    formRegion: "Khu vực bán hàng",
    formVolume: "Sản lượng hàng tháng dự kiến",
    formTimeline: "Thời điểm ra mắt mục tiêu",
    formSubmitting: "Đang gửi",
    validationRequired: "Trường này là bắt buộc.",
    validationEmail: "Nhập địa chỉ email hợp lệ.",
    error: "Có lỗi khi gửi yêu cầu.",
    prefillAffiliate: "Tôi muốn đăng ký chương trình affiliate của LUKKEY.\n\nKênh / khán giả:\nKhu vực:\nHình thức hợp tác dự kiến:\nLiên kết liên quan:",
    prefillReseller: "Tôi muốn đăng ký chương trình đại lý của LUKKEY.\n\nCông ty / cửa hàng:\nKênh bán hàng:\nKhu vực:\nSản lượng hàng tháng dự kiến:\nLiên kết liên quan:",
    prefillCobranding: "Tôi muốn trao đổi về hợp tác đồng thương hiệu với LUKKEY.\n\nThương hiệu / dự án:\nÝ tưởng chiến dịch:\nThời điểm ra mắt mục tiêu:\nYêu cầu thiết kế hoặc sản phẩm:\nLiên kết liên quan:",
  }),
  id: buildPartnerInquiryTranslations({
    programAffiliate: "Afiliasi",
    programReseller: "Reseller",
    programCobranding: "Co-branding",
    affiliateSeoTitle: "Aplikasi afiliasi LUKKEY | Program kreator",
    affiliateSeoDescription: "Daftar untuk bergabung dengan LUKKEY sebagai kreator atau partner afiliasi.",
    affiliateBadge: "Afiliasi kreator",
    affiliateTitle: "Jadi partner kreator LUKKEY.",
    affiliateSubtitle: "Formulir cepat dan ramah untuk kreator, reviewer, edukator, dan komunitas.",
    affiliatePoint1: "Aplikasi sederhana untuk kreator",
    affiliatePoint2: "Bagikan channel dan kecocokan audiens",
    affiliatePoint3: "Tim LUKKEY akan menghubungi lewat email",
    affiliateMessageLabel: "Ceritakan tentang konten Anda",
    affiliateSubmit: "Daftar sebagai partner kreator",
    affiliateSuccess: "Aplikasi partner kreator Anda telah dikirim.",
    resellerSeoTitle: "Aplikasi reseller LUKKEY | Kemitraan bisnis",
    resellerSeoDescription: "Daftar untuk menjadi reseller atau partner channel penjualan LUKKEY.",
    resellerBadge: "Aplikasi reseller",
    resellerTitle: "Daftar menjadi reseller LUKKEY.",
    resellerSubtitle: "Formulir B2B ringkas untuk toko, distributor, dan channel penjualan.",
    resellerPoint1: "Profil bisnis dan wilayah penjualan",
    resellerPoint2: "Kecocokan channel dan volume perkiraan",
    resellerPoint3: "Tindak lanjut profesional dari tim kemitraan",
    resellerMessageLabel: "Kebutuhan bisnis",
    resellerSubmit: "Kirim aplikasi reseller",
    resellerSuccess: "Aplikasi reseller Anda telah dikirim.",
    cobrandingSeoTitle: "Permintaan co-branding LUKKEY | Kolaborasi brand",
    cobrandingSeoDescription: "Mulai permintaan kolaborasi co-branding dengan LUKKEY.",
    cobrandingBadge: "Kolaborasi brand",
    cobrandingTitle: "Mulai percakapan co-branding.",
    cobrandingSubtitle: "Formulir B2B fokus untuk campaign, produk, dan peluncuran.",
    cobrandingPoint1: "Konteks brand, campaign, dan peluncuran",
    cobrandingPoint2: "Kebutuhan desain atau produk",
    cobrandingPoint3: "Ditinjau oleh tim kemitraan LUKKEY",
    cobrandingMessageLabel: "Brief kolaborasi",
    cobrandingSubmit: "Kirim permintaan co-branding",
    cobrandingSuccess: "Permintaan co-branding Anda telah dikirim.",
    formName: "Nama",
    formEmail: "Email",
    formCompany: "Perusahaan / channel",
    formWebsite: "Website atau tautan sosial",
    formChannel: "Channel utama atau tautan sosial",
    formAudience: "Audiens atau komunitas",
    formRegion: "Wilayah penjualan",
    formVolume: "Perkiraan volume bulanan",
    formTimeline: "Target waktu peluncuran",
    formSubmitting: "Mengirim",
    validationRequired: "Kolom ini wajib diisi.",
    validationEmail: "Masukkan alamat email yang valid.",
    error: "Terjadi kesalahan saat mengirim permintaan.",
    prefillAffiliate: "Saya ingin mendaftar program afiliasi LUKKEY.\n\nChannel / audiens:\nWilayah:\nFormat kolaborasi yang diharapkan:\nTautan relevan:",
    prefillReseller: "Saya ingin mendaftar program reseller LUKKEY.\n\nPerusahaan / toko:\nChannel penjualan:\nWilayah:\nPerkiraan volume bulanan:\nTautan relevan:",
    prefillCobranding: "Saya ingin membahas kolaborasi co-branding dengan LUKKEY.\n\nBrand / proyek:\nIde campaign:\nTarget waktu peluncuran:\nKebutuhan desain atau produk:\nTautan relevan:",
  }),
  tl: buildPartnerInquiryTranslations({
    programAffiliate: "Affiliate",
    programReseller: "Reseller",
    programCobranding: "Co-branding",
    affiliateSeoTitle: "LUKKEY affiliate application | Creator program",
    affiliateSeoDescription: "Mag-apply para sumali sa LUKKEY bilang creator o affiliate partner.",
    affiliateBadge: "Creator affiliate",
    affiliateTitle: "Maging creator partner ng LUKKEY.",
    affiliateSubtitle: "Mabilis at friendly na application para sa creators, reviewers, educators, at communities.",
    affiliatePoint1: "Simpleng application para sa creators",
    affiliatePoint2: "Ibahagi ang channel at audience fit",
    affiliatePoint3: "Magfa-follow up ang LUKKEY team sa email",
    affiliateMessageLabel: "Ikuwento ang iyong content",
    affiliateSubmit: "Mag-apply bilang creator partner",
    affiliateSuccess: "Naipadala na ang iyong creator partner application.",
    resellerSeoTitle: "LUKKEY reseller application | Business partnership",
    resellerSeoDescription: "Mag-apply para maging LUKKEY reseller o sales channel partner.",
    resellerBadge: "Reseller application",
    resellerTitle: "Mag-apply para maging LUKKEY reseller.",
    resellerSubtitle: "Maikling B2B form para sa stores, distributors, at sales channels.",
    resellerPoint1: "Business profile at sales region",
    resellerPoint2: "Channel fit at expected volume",
    resellerPoint3: "Professional follow-up mula sa partnership sales",
    resellerMessageLabel: "Business requirements",
    resellerSubmit: "Isumite ang reseller application",
    resellerSuccess: "Naipadala na ang iyong reseller application.",
    cobrandingSeoTitle: "LUKKEY co-branding inquiry | Brand collaboration",
    cobrandingSeoDescription: "Magsimula ng co-branding collaboration inquiry sa LUKKEY.",
    cobrandingBadge: "Brand collaboration",
    cobrandingTitle: "Magsimula ng co-branding conversation.",
    cobrandingSubtitle: "Focused B2B form para sa campaigns, products, at launches.",
    cobrandingPoint1: "Brand, campaign, at launch context",
    cobrandingPoint2: "Design o product requirements",
    cobrandingPoint3: "Susuriin ng LUKKEY partnership team",
    cobrandingMessageLabel: "Collaboration brief",
    cobrandingSubmit: "Isumite ang co-branding inquiry",
    cobrandingSuccess: "Naipadala na ang iyong co-branding inquiry.",
    formName: "Pangalan",
    formEmail: "Email",
    formCompany: "Kompanya / channel",
    formWebsite: "Website o social link",
    formChannel: "Main channel o social link",
    formAudience: "Audience o community",
    formRegion: "Sales region",
    formVolume: "Expected monthly volume",
    formTimeline: "Target launch timing",
    formSubmitting: "Ipinapadala",
    validationRequired: "Kailangan ang field na ito.",
    validationEmail: "Maglagay ng valid na email address.",
    error: "Nagkaroon ng error sa pagpapadala ng inquiry.",
    prefillAffiliate: "Gusto kong mag-apply sa LUKKEY affiliate program.\n\nChannel / audience:\nRegion:\nExpected collaboration format:\nRelevant links:",
    prefillReseller: "Gusto kong mag-apply sa LUKKEY reseller program.\n\nCompany / store name:\nSales channels:\nRegion:\nExpected monthly volume:\nRelevant links:",
    prefillCobranding: "Gusto kong pag-usapan ang co-branding collaboration sa LUKKEY.\n\nBrand / project:\nCampaign idea:\nTarget launch timing:\nDesign o product requirements:\nRelevant links:",
  }),
  bn: buildPartnerInquiryTranslations({
    programAffiliate: "অ্যাফিলিয়েট",
    programReseller: "রিসেলার",
    programCobranding: "কো-ব্র্যান্ডিং",
    affiliateSeoTitle: "LUKKEY অ্যাফিলিয়েট আবেদন | ক্রিয়েটর প্রোগ্রাম",
    affiliateSeoDescription: "ক্রিয়েটর বা অ্যাফিলিয়েট পার্টনার হিসেবে LUKKEY-তে আবেদন করুন।",
    affiliateBadge: "ক্রিয়েটর অ্যাফিলিয়েট",
    affiliateTitle: "LUKKEY ক্রিয়েটর পার্টনার হন।",
    affiliateSubtitle: "ক্রিয়েটর, রিভিউয়ার, শিক্ষাবিদ ও কমিউনিটির জন্য দ্রুত ও সহজ আবেদন।",
    affiliatePoint1: "ক্রিয়েটরদের জন্য সহজ আবেদন",
    affiliatePoint2: "আপনার চ্যানেল ও অডিয়েন্স জানান",
    affiliatePoint3: "LUKKEY টিম ইমেইলে যোগাযোগ করবে",
    affiliateMessageLabel: "আপনার কনটেন্ট সম্পর্কে বলুন",
    affiliateSubmit: "ক্রিয়েটর পার্টনার হিসেবে আবেদন করুন",
    affiliateSuccess: "আপনার ক্রিয়েটর পার্টনার আবেদন পাঠানো হয়েছে।",
    resellerSeoTitle: "LUKKEY রিসেলার আবেদন | ব্যবসায়িক অংশীদারিত্ব",
    resellerSeoDescription: "LUKKEY রিসেলার বা বিক্রয় চ্যানেল পার্টনার হতে আবেদন করুন।",
    resellerBadge: "রিসেলার আবেদন",
    resellerTitle: "LUKKEY রিসেলার হতে আবেদন করুন।",
    resellerSubtitle: "দোকান, ডিস্ট্রিবিউটর ও বিক্রয় চ্যানেলের জন্য সংক্ষিপ্ত B2B ফর্ম।",
    resellerPoint1: "ব্যবসার প্রোফাইল ও বিক্রয় অঞ্চল",
    resellerPoint2: "চ্যানেল ফিট ও প্রত্যাশিত ভলিউম",
    resellerPoint3: "পার্টনারশিপ টিমের পেশাদার ফলো-আপ",
    resellerMessageLabel: "ব্যবসায়িক প্রয়োজন",
    resellerSubmit: "রিসেলার আবেদন পাঠান",
    resellerSuccess: "আপনার রিসেলার আবেদন পাঠানো হয়েছে।",
    cobrandingSeoTitle: "LUKKEY কো-ব্র্যান্ডিং অনুসন্ধান | ব্র্যান্ড সহযোগিতা",
    cobrandingSeoDescription: "LUKKEY-এর সঙ্গে কো-ব্র্যান্ডিং সহযোগিতার অনুসন্ধান শুরু করুন।",
    cobrandingBadge: "ব্র্যান্ড সহযোগিতা",
    cobrandingTitle: "কো-ব্র্যান্ডিং আলোচনা শুরু করুন।",
    cobrandingSubtitle: "ক্যাম্পেইন, পণ্য ও লঞ্চ সহযোগিতার জন্য ফোকাসড B2B ফর্ম।",
    cobrandingPoint1: "ব্র্যান্ড, ক্যাম্পেইন ও লঞ্চ প্রেক্ষাপট",
    cobrandingPoint2: "ডিজাইন বা পণ্যের প্রয়োজন",
    cobrandingPoint3: "LUKKEY পার্টনারশিপ টিম পর্যালোচনা করবে",
    cobrandingMessageLabel: "সহযোগিতার ব্রিফ",
    cobrandingSubmit: "কো-ব্র্যান্ডিং অনুসন্ধান পাঠান",
    cobrandingSuccess: "আপনার কো-ব্র্যান্ডিং অনুসন্ধান পাঠানো হয়েছে।",
    formName: "নাম",
    formEmail: "ইমেইল",
    formCompany: "কোম্পানি / চ্যানেল",
    formWebsite: "ওয়েবসাইট বা সোশ্যাল লিংক",
    formChannel: "প্রধান চ্যানেল বা সোশ্যাল লিংক",
    formAudience: "অডিয়েন্স বা কমিউনিটি",
    formRegion: "বিক্রয় অঞ্চল",
    formVolume: "প্রত্যাশিত মাসিক ভলিউম",
    formTimeline: "লক্ষ্য লঞ্চ সময়",
    formSubmitting: "পাঠানো হচ্ছে",
    validationRequired: "এই ঘরটি আবশ্যক।",
    validationEmail: "একটি বৈধ ইমেইল ঠিকানা লিখুন।",
    error: "আপনার অনুসন্ধান পাঠাতে ত্রুটি হয়েছে।",
    prefillAffiliate: "আমি LUKKEY অ্যাফিলিয়েট প্রোগ্রামে আবেদন করতে চাই।\n\nচ্যানেল / অডিয়েন্স:\nঅঞ্চল:\nপ্রত্যাশিত সহযোগিতার ধরন:\nপ্রাসঙ্গিক লিংক:",
    prefillReseller: "আমি LUKKEY রিসেলার প্রোগ্রামে আবেদন করতে চাই।\n\nকোম্পানি / দোকান:\nবিক্রয় চ্যানেল:\nঅঞ্চল:\nপ্রত্যাশিত মাসিক ভলিউম:\nপ্রাসঙ্গিক লিংক:",
    prefillCobranding: "আমি LUKKEY-এর সঙ্গে কো-ব্র্যান্ডিং সহযোগিতা নিয়ে আলোচনা করতে চাই।\n\nব্র্যান্ড / প্রজেক্ট:\nক্যাম্পেইন আইডিয়া:\nলক্ষ্য লঞ্চ সময়:\nডিজাইন বা পণ্যের প্রয়োজন:\nপ্রাসঙ্গিক লিংক:",
  }),
};

partnerInquiryLocaleTranslations["pt-BR"] = partnerInquiryLocaleTranslations.pt;

const partnerFooterTranslations = {
  fr: {
    "partners.badge": "Programmes partenaires",
    "coBranding.title": "Co-branding",
  },
  es: {
    "partners.badge": "Programas de socios",
    "coBranding.title": "Co-branding",
  },
  ar: {
    "partners.badge": "برامج الشركاء",
    "coBranding.title": "تعاون العلامة",
  },
  ja: {
    "partners.badge": "パートナープログラム",
    "coBranding.title": "共同ブランド",
  },
  ru: {
    "partners.badge": "Партнерские программы",
    "coBranding.title": "Кобрендинг",
  },
  ko: {
    "partners.badge": "파트너 프로그램",
    "coBranding.title": "공동 브랜딩",
  },
  pt: {
    "partners.badge": "Programas de parceiros",
    "coBranding.title": "Co-branding",
  },
  "pt-BR": {
    "partners.badge": "Programas de parceiros",
    "coBranding.title": "Co-branding",
  },
  it: {
    "partners.badge": "Programmi partner",
    "coBranding.title": "Co-branding",
  },
  de: {
    "partners.badge": "Partnerprogramme",
    "coBranding.title": "Co-Branding",
  },
  hi: {
    "partners.badge": "पार्टनर प्रोग्राम",
    "coBranding.title": "को-ब्रांडिंग",
  },
  mn: {
    "partners.badge": "Түншлэлийн хөтөлбөрүүд",
    "coBranding.title": "Хамтарсан брэнд",
  },
  th: {
    "partners.badge": "โปรแกรมพาร์ทเนอร์",
    "coBranding.title": "โคแบรนด์",
  },
  uk: {
    "partners.seoTitle": "Партнерські програми LUKKEY | Афіліати та реселери",
    "partners.seoDescription": "Приєднуйтеся до LUKKEY як афіліат, автор, реселер або продуктовий партнер.",
    "partners.badge": "Партнерські програми",
    "partners.title": "Працюйте з LUKKEY.",
    "partners.programs.affiliate.title": "Афіліат",
    "partners.programs.affiliate.intro": "Ви автор, оглядач, освітній експерт або KOL у сфері криптобезпеки?",
    "partners.programs.affiliate.body": "Приєднуйтеся до LUKKEY, просувайте надійні self-custody продукти та отримуйте винагороди.",
    "partners.programs.affiliate.benefit1": "Привабливі комісії",
    "partners.programs.affiliate.benefit2": "Прямі відносини з LUKKEY",
    "partners.programs.affiliate.benefit3": "Ранній доступ до оновлень LUKKEY",
    "partners.programs.affiliate.cta": "Стати афіліатом LUKKEY",
    "partners.programs.reseller.title": "Реселер",
    "partners.programs.reseller.intro": "Хочете продавати продукти LUKKEY через сайт, магазин або канал?",
    "partners.programs.reseller.body": "Приєднуйтеся до програми реселерів LUKKEY і пропонуйте клієнтам безпечні апаратні гаманці.",
    "partners.programs.reseller.benefit1": "Переважні партнерські ціни",
    "partners.programs.reseller.benefit2": "Підтримка customer success",
    "partners.programs.reseller.benefit3": "Спільний маркетинг і план запуску",
    "partners.programs.reseller.cta": "Стати реселером LUKKEY",
    "coBranding.seoTitle": "Кобрендинг LUKKEY | Партнерська співпраця",
    "coBranding.seoDescription": "Створюйте кобрендингові кампанії апаратних гаманців LUKKEY, дизайн-матеріали та партнерські запуски.",
    "coBranding.badge": "Партнерська співпраця",
    "coBranding.title": "Кобрендинг",
    "coBranding.subtitle": "Перетворіть безпечне обладнання на преміальний момент бренду з лімітованими кобрендинговими гаманцями, launch assets і підтримкою кампанії.",
    "coBranding.cta": "Почати кобрендинг-проєкт",
    "coBranding.card.hardware": "Обладнання",
    "coBranding.card.brandKit": "Бренд-кіт",
    "coBranding.card.launch": "Запуск",
    "coBranding.card.packaging": "Пакування",
    "coBranding.card.campaign": "Кампанія",
    "coBranding.card.retail": "Ритейл",
    "coBranding.card.creator": "Автор",
    "coBranding.card.event": "Подія",
  },
  vi: {
    "partners.seoTitle": "Chương trình đối tác LUKKEY | Affiliate và đại lý",
    "partners.seoDescription": "Tham gia LUKKEY với vai trò affiliate, creator, đại lý hoặc đối tác sản phẩm.",
    "partners.badge": "Chương trình đối tác",
    "partners.title": "Hợp tác với LUKKEY.",
    "partners.programs.affiliate.title": "Affiliate",
    "partners.programs.affiliate.intro": "Bạn là creator, reviewer, educator hoặc KOL trong lĩnh vực bảo mật crypto?",
    "partners.programs.affiliate.body": "Tham gia LUKKEY, quảng bá sản phẩm self-custody đáng tin cậy và nhận thưởng đối tác.",
    "partners.programs.affiliate.benefit1": "Hoa hồng hấp dẫn",
    "partners.programs.affiliate.benefit2": "Quan hệ trực tiếp với LUKKEY",
    "partners.programs.affiliate.benefit3": "Truy cập sớm cập nhật LUKKEY",
    "partners.programs.affiliate.cta": "Trở thành affiliate LUKKEY",
    "partners.programs.reseller.title": "Đại lý",
    "partners.programs.reseller.intro": "Bạn muốn bán sản phẩm LUKKEY qua website, cửa hàng hoặc kênh của mình?",
    "partners.programs.reseller.body": "Tham gia chương trình đại lý LUKKEY và mang ví phần cứng an toàn đến khách hàng.",
    "partners.programs.reseller.benefit1": "Giá đối tác ưu đãi",
    "partners.programs.reseller.benefit2": "Hỗ trợ customer success",
    "partners.programs.reseller.benefit3": "Đồng tiếp thị và kế hoạch ra mắt",
    "partners.programs.reseller.cta": "Trở thành đại lý LUKKEY",
    "coBranding.seoTitle": "Đồng thương hiệu LUKKEY | Hợp tác đối tác",
    "coBranding.seoDescription": "Tạo chiến dịch ví phần cứng đồng thương hiệu LUKKEY, tài sản thiết kế và ra mắt cùng đối tác.",
    "coBranding.badge": "Hợp tác đối tác",
    "coBranding.title": "Đồng thương hiệu",
    "coBranding.subtitle": "Biến phần cứng an toàn thành khoảnh khắc thương hiệu cao cấp với ví đồng thương hiệu giới hạn, tài sản ra mắt và hỗ trợ chiến dịch.",
    "coBranding.cta": "Bắt đầu dự án đồng thương hiệu",
    "coBranding.card.hardware": "Phần cứng",
    "coBranding.card.brandKit": "Bộ thương hiệu",
    "coBranding.card.launch": "Ra mắt",
    "coBranding.card.packaging": "Bao bì",
    "coBranding.card.campaign": "Chiến dịch",
    "coBranding.card.retail": "Bán lẻ",
    "coBranding.card.creator": "Creator",
    "coBranding.card.event": "Sự kiện",
  },
  id: {
    "partners.seoTitle": "Program partner LUKKEY | Affiliate dan reseller",
    "partners.seoDescription": "Bergabung dengan LUKKEY sebagai affiliate, creator, reseller, atau partner produk.",
    "partners.badge": "Program partner",
    "partners.title": "Bekerja dengan LUKKEY.",
    "partners.programs.affiliate.title": "Affiliate",
    "partners.programs.affiliate.intro": "Apakah Anda creator, reviewer, educator, atau KOL di bidang keamanan kripto?",
    "partners.programs.affiliate.body": "Bergabung dengan LUKKEY, promosikan produk self-custody tepercaya, dan dapatkan reward partner.",
    "partners.programs.affiliate.benefit1": "Komisi menarik",
    "partners.programs.affiliate.benefit2": "Hubungan langsung dengan LUKKEY",
    "partners.programs.affiliate.benefit3": "Akses awal ke update LUKKEY",
    "partners.programs.affiliate.cta": "Menjadi affiliate LUKKEY",
    "partners.programs.reseller.title": "Reseller",
    "partners.programs.reseller.intro": "Ingin menjual produk LUKKEY melalui website, toko, atau channel Anda?",
    "partners.programs.reseller.body": "Bergabung dengan program reseller LUKKEY dan hadirkan hardware wallet aman untuk pelanggan Anda.",
    "partners.programs.reseller.benefit1": "Harga partner prioritas",
    "partners.programs.reseller.benefit2": "Dukungan customer success",
    "partners.programs.reseller.benefit3": "Co-marketing dan rencana peluncuran",
    "partners.programs.reseller.cta": "Menjadi reseller LUKKEY",
    "coBranding.seoTitle": "Co-branding LUKKEY | Kolaborasi partner",
    "coBranding.seoDescription": "Buat kampanye hardware wallet co-branded LUKKEY, aset desain, dan peluncuran partner.",
    "coBranding.badge": "Kolaborasi partner",
    "coBranding.title": "Co-branding",
    "coBranding.subtitle": "Ubah hardware aman menjadi momen brand premium dengan wallet co-branded terbatas, aset peluncuran, dan dukungan kampanye.",
    "coBranding.cta": "Mulai proyek co-branding",
    "coBranding.card.hardware": "Hardware",
    "coBranding.card.brandKit": "Brand kit",
    "coBranding.card.launch": "Peluncuran",
    "coBranding.card.packaging": "Kemasan",
    "coBranding.card.campaign": "Kampanye",
    "coBranding.card.retail": "Retail",
    "coBranding.card.creator": "Creator",
    "coBranding.card.event": "Event",
  },
  tl: {
    "partners.seoTitle": "LUKKEY partner programs | Affiliate at reseller",
    "partners.seoDescription": "Sumali sa LUKKEY bilang affiliate, creator, reseller, o product partner.",
    "partners.badge": "Partner programs",
    "partners.title": "Makipagtulungan sa LUKKEY.",
    "partners.programs.affiliate.title": "Affiliate",
    "partners.programs.affiliate.intro": "Ikaw ba ay creator, reviewer, educator, o KOL sa crypto security?",
    "partners.programs.affiliate.body": "Sumali sa LUKKEY, i-promote ang trusted self-custody products, at kumita ng partner rewards.",
    "partners.programs.affiliate.benefit1": "Kaakit-akit na komisyon",
    "partners.programs.affiliate.benefit2": "Direktang ugnayan sa LUKKEY",
    "partners.programs.affiliate.benefit3": "Maagang access sa LUKKEY updates",
    "partners.programs.affiliate.cta": "Maging LUKKEY affiliate",
    "partners.programs.reseller.title": "Reseller",
    "partners.programs.reseller.intro": "Gusto mo bang magbenta ng LUKKEY products sa iyong website, shop, o channel?",
    "partners.programs.reseller.body": "Sumali sa LUKKEY reseller program at dalhin ang secure hardware wallets sa iyong customers.",
    "partners.programs.reseller.benefit1": "Preferred partner pricing",
    "partners.programs.reseller.benefit2": "Customer success support",
    "partners.programs.reseller.benefit3": "Co-marketing at launch planning",
    "partners.programs.reseller.cta": "Maging LUKKEY reseller",
    "coBranding.seoTitle": "LUKKEY co-branding | Partner collaboration",
    "coBranding.seoDescription": "Gumawa ng co-branded LUKKEY hardware wallet campaigns, design assets, at partner launches.",
    "coBranding.badge": "Partner collaboration",
    "coBranding.title": "Co-branding",
    "coBranding.subtitle": "Gawing premium brand moment ang secure hardware gamit ang limited co-branded wallets, launch assets, at campaign support.",
    "coBranding.cta": "Simulan ang co-branding project",
    "coBranding.card.hardware": "Hardware",
    "coBranding.card.brandKit": "Brand kit",
    "coBranding.card.launch": "Launch",
    "coBranding.card.packaging": "Packaging",
    "coBranding.card.campaign": "Campaign",
    "coBranding.card.retail": "Retail",
    "coBranding.card.creator": "Creator",
    "coBranding.card.event": "Event",
  },
  bn: {
    "partners.seoTitle": "LUKKEY পার্টনার প্রোগ্রাম | অ্যাফিলিয়েট ও রিসেলার",
    "partners.seoDescription": "অ্যাফিলিয়েট, ক্রিয়েটর, রিসেলার বা পণ্য পার্টনার হিসেবে LUKKEY-তে যোগ দিন।",
    "partners.badge": "পার্টনার প্রোগ্রাম",
    "partners.title": "LUKKEY-এর সঙ্গে কাজ করুন।",
    "partners.programs.affiliate.title": "অ্যাফিলিয়েট",
    "partners.programs.affiliate.intro": "আপনি কি crypto security ক্ষেত্রের creator, reviewer, educator বা KOL?",
    "partners.programs.affiliate.body": "LUKKEY-তে যোগ দিন, trusted self-custody পণ্য প্রচার করুন এবং partner rewards পান।",
    "partners.programs.affiliate.benefit1": "আকর্ষণীয় কমিশন",
    "partners.programs.affiliate.benefit2": "LUKKEY-এর সঙ্গে সরাসরি সম্পর্ক",
    "partners.programs.affiliate.benefit3": "LUKKEY আপডেটে আগাম অ্যাক্সেস",
    "partners.programs.affiliate.cta": "LUKKEY অ্যাফিলিয়েট হন",
    "partners.programs.reseller.title": "রিসেলার",
    "partners.programs.reseller.intro": "আপনি কি আপনার website, shop বা channel-এ LUKKEY পণ্য বিক্রি করতে চান?",
    "partners.programs.reseller.body": "LUKKEY reseller program-এ যোগ দিন এবং নিরাপদ hardware wallet আপনার customers-কে দিন।",
    "partners.programs.reseller.benefit1": "Preferred partner pricing",
    "partners.programs.reseller.benefit2": "Customer success support",
    "partners.programs.reseller.benefit3": "Co-marketing এবং launch planning",
    "partners.programs.reseller.cta": "LUKKEY রিসেলার হন",
    "coBranding.seoTitle": "LUKKEY কো-ব্র্যান্ডিং | পার্টনার সহযোগিতা",
    "coBranding.seoDescription": "Co-branded LUKKEY hardware wallet campaigns, design assets এবং partner launches তৈরি করুন।",
    "coBranding.badge": "পার্টনার সহযোগিতা",
    "coBranding.title": "কো-ব্র্যান্ডিং",
    "coBranding.subtitle": "Limited co-branded wallets, launch assets এবং campaign support দিয়ে secure hardware-কে premium brand moment-এ রূপ দিন।",
    "coBranding.cta": "কো-ব্র্যান্ডিং প্রজেক্ট শুরু করুন",
    "coBranding.card.hardware": "Hardware",
    "coBranding.card.brandKit": "Brand kit",
    "coBranding.card.launch": "Launch",
    "coBranding.card.packaging": "Packaging",
    "coBranding.card.campaign": "Campaign",
    "coBranding.card.retail": "Retail",
    "coBranding.card.creator": "Creator",
    "coBranding.card.event": "Event",
  },
};

const partnerPageEnglishTranslations = {
  "partners.seoTitle": "LUKKEY Partner Programs | Affiliate and Reseller",
  "partners.seoDescription": "Join LUKKEY as an affiliate, creator, reseller, or product partner.",
  "partners.badge": "Partner Programs",
  "partners.title": "Work with LUKKEY.",
  "partners.programs.affiliate.title": "Affiliate",
  "partners.programs.affiliate.intro": "Are you a creator, reviewer, educator, or KOL in the crypto security space?",
  "partners.programs.affiliate.body": "Join LUKKEY, promote trusted self-custody products, and earn partner rewards.",
  "partners.programs.affiliate.benefit1": "Attractive commissions",
  "partners.programs.affiliate.benefit2": "Direct relationship with LUKKEY",
  "partners.programs.affiliate.benefit3": "Early access to LUKKEY updates",
  "partners.programs.affiliate.cta": "Become a LUKKEY affiliate",
  "partners.programs.reseller.title": "Reseller",
  "partners.programs.reseller.intro": "Do you want to sell LUKKEY products through your website, shop, or channel?",
  "partners.programs.reseller.body": "Join the LUKKEY reseller program and bring secure hardware wallets to your customers.",
  "partners.programs.reseller.benefit1": "Preferred partner pricing",
  "partners.programs.reseller.benefit2": "Customer success support",
  "partners.programs.reseller.benefit3": "Co-marketing and launch planning",
  "partners.programs.reseller.cta": "Become a LUKKEY reseller",
  "coBranding.seoTitle": "LUKKEY Co-branding | Partner Collaboration",
  "coBranding.seoDescription": "Create co-branded LUKKEY hardware wallet campaigns, design assets, and partner launches.",
  "coBranding.badge": "Partner Collaboration",
  "coBranding.title": "Co-branding",
  "coBranding.subtitle": "Turn secure hardware into a premium brand moment with limited co-branded wallets, launch assets, and campaign support.",
  "coBranding.cta": "Start a co-branding project",
  "coBranding.card.hardware": "Hardware",
  "coBranding.card.brandKit": "Brand kit",
  "coBranding.card.launch": "Launch",
  "coBranding.card.packaging": "Packaging",
  "coBranding.card.campaign": "Campaign",
  "coBranding.card.retail": "Retail",
  "coBranding.card.creator": "Creator",
  "coBranding.card.event": "Event",
};

const partnerPageLocaleTranslations = Object.fromEntries(
  Object.keys(partnerFooterTranslations).map((locale) => [
    locale,
    {
      ...partnerPageEnglishTranslations,
      ...(partnerFooterTranslations[locale] || {}),
    },
  ]),
);

partnerPageLocaleTranslations["pt-BR"] = partnerPageLocaleTranslations.pt;

Object.assign(partnerPageLocaleTranslations, {
  fr: {
    "partners.seoTitle": "Programmes partenaires LUKKEY | Affiliés et revendeurs",
    "partners.seoDescription": "Rejoignez LUKKEY comme affilié, créateur, revendeur ou partenaire produit.",
    "partners.badge": "Programmes partenaires",
    "partners.title": "Collaborez avec LUKKEY.",
    "partners.programs.affiliate.title": "Affilié",
    "partners.programs.affiliate.intro": "Vous êtes créateur, testeur, formateur ou KOL dans la sécurité crypto ?",
    "partners.programs.affiliate.body": "Rejoignez LUKKEY, recommandez des produits self-custody fiables et gagnez des récompenses partenaires.",
    "partners.programs.affiliate.benefit1": "Commissions attractives",
    "partners.programs.affiliate.benefit2": "Relation directe avec LUKKEY",
    "partners.programs.affiliate.benefit3": "Accès anticipé aux nouveautés LUKKEY",
    "partners.programs.affiliate.cta": "Devenir affilié LUKKEY",
    "partners.programs.reseller.title": "Revendeur",
    "partners.programs.reseller.intro": "Vous souhaitez vendre les produits LUKKEY via votre site, boutique ou canal ?",
    "partners.programs.reseller.body": "Rejoignez le programme revendeur LUKKEY et proposez des portefeuilles matériels sécurisés à vos clients.",
    "partners.programs.reseller.benefit1": "Tarifs partenaires préférentiels",
    "partners.programs.reseller.benefit2": "Support customer success",
    "partners.programs.reseller.benefit3": "Co-marketing et plan de lancement",
    "partners.programs.reseller.cta": "Devenir revendeur LUKKEY",
    "coBranding.seoTitle": "Co-branding LUKKEY | Collaboration partenaire",
    "coBranding.seoDescription": "Créez des campagnes de wallets matériels co-brandés LUKKEY, des assets design et des lancements partenaires.",
    "coBranding.badge": "Collaboration partenaire",
    "coBranding.title": "Co-branding",
    "coBranding.subtitle": "Transformez le hardware sécurisé en moment de marque premium avec des wallets co-brandés limités, des assets de lancement et un support campagne.",
    "coBranding.cta": "Lancer un projet co-branding",
    "coBranding.card.hardware": "Hardware",
    "coBranding.card.brandKit": "Kit de marque",
    "coBranding.card.launch": "Lancement",
    "coBranding.card.packaging": "Packaging",
    "coBranding.card.campaign": "Campagne",
    "coBranding.card.retail": "Retail",
    "coBranding.card.creator": "Créateur",
    "coBranding.card.event": "Événement",
  },
  es: {
    "partners.seoTitle": "Programas de partners LUKKEY | Afiliados y distribuidores",
    "partners.seoDescription": "Únete a LUKKEY como afiliado, creador, distribuidor o partner de producto.",
    "partners.badge": "Programas de partners",
    "partners.title": "Trabaja con LUKKEY.",
    "partners.programs.affiliate.title": "Afiliado",
    "partners.programs.affiliate.intro": "¿Eres creador, reviewer, educador o KOL en seguridad cripto?",
    "partners.programs.affiliate.body": "Únete a LUKKEY, promociona productos self-custody confiables y gana recompensas de partner.",
    "partners.programs.affiliate.benefit1": "Comisiones atractivas",
    "partners.programs.affiliate.benefit2": "Relación directa con LUKKEY",
    "partners.programs.affiliate.benefit3": "Acceso anticipado a novedades de LUKKEY",
    "partners.programs.affiliate.cta": "Ser afiliado LUKKEY",
    "partners.programs.reseller.title": "Distribuidor",
    "partners.programs.reseller.intro": "¿Quieres vender productos LUKKEY en tu web, tienda o canal?",
    "partners.programs.reseller.body": "Únete al programa de distribuidores LUKKEY y lleva wallets hardware seguros a tus clientes.",
    "partners.programs.reseller.benefit1": "Precio preferente para partners",
    "partners.programs.reseller.benefit2": "Soporte de customer success",
    "partners.programs.reseller.benefit3": "Co-marketing y planificación de lanzamiento",
    "partners.programs.reseller.cta": "Ser distribuidor LUKKEY",
    "coBranding.seoTitle": "Co-branding LUKKEY | Colaboración de partners",
    "coBranding.seoDescription": "Crea campañas con wallets hardware co-branded LUKKEY, assets de diseño y lanzamientos con partners.",
    "coBranding.badge": "Colaboración de partners",
    "coBranding.title": "Co-branding",
    "coBranding.subtitle": "Convierte el hardware seguro en un momento de marca premium con wallets co-branded limitados, assets de lanzamiento y soporte de campaña.",
    "coBranding.cta": "Iniciar un proyecto co-branding",
    "coBranding.card.hardware": "Hardware",
    "coBranding.card.brandKit": "Kit de marca",
    "coBranding.card.launch": "Lanzamiento",
    "coBranding.card.packaging": "Packaging",
    "coBranding.card.campaign": "Campaña",
    "coBranding.card.retail": "Retail",
    "coBranding.card.creator": "Creador",
    "coBranding.card.event": "Evento",
  },
  ar: {
    "partners.seoTitle": "برامج شركاء LUKKEY | الأفلييت والموزعون",
    "partners.seoDescription": "انضم إلى LUKKEY كشريك أفلييت أو صانع محتوى أو موزع أو شريك منتج.",
    "partners.badge": "برامج الشركاء",
    "partners.title": "تعاون مع LUKKEY.",
    "partners.programs.affiliate.title": "أفلييت",
    "partners.programs.affiliate.intro": "هل أنت صانع محتوى أو مراجع أو مدرب أو مؤثر في مجال أمن العملات المشفرة؟",
    "partners.programs.affiliate.body": "انضم إلى LUKKEY وروّج لمنتجات حفظ ذاتي موثوقة واحصل على مكافآت الشركاء.",
    "partners.programs.affiliate.benefit1": "عمولات جذابة",
    "partners.programs.affiliate.benefit2": "علاقة مباشرة مع LUKKEY",
    "partners.programs.affiliate.benefit3": "وصول مبكر إلى تحديثات LUKKEY",
    "partners.programs.affiliate.cta": "كن شريك أفلييت LUKKEY",
    "partners.programs.reseller.title": "موزع",
    "partners.programs.reseller.intro": "هل تريد بيع منتجات LUKKEY عبر موقعك أو متجرك أو قناتك؟",
    "partners.programs.reseller.body": "انضم إلى برنامج موزعي LUKKEY وقدّم محافظ أجهزة آمنة لعملائك.",
    "partners.programs.reseller.benefit1": "أسعار تفضيلية للشركاء",
    "partners.programs.reseller.benefit2": "دعم نجاح العملاء",
    "partners.programs.reseller.benefit3": "تسويق مشترك وتخطيط للإطلاق",
    "partners.programs.reseller.cta": "كن موزع LUKKEY",
    "coBranding.seoTitle": "التعاون المشترك مع LUKKEY | شراكات العلامات",
    "coBranding.seoDescription": "أنشئ حملات محافظ أجهزة مشتركة مع LUKKEY ومواد تصميم وإطلاقات شراكة.",
    "coBranding.badge": "تعاون الشركاء",
    "coBranding.title": "تعاون العلامة",
    "coBranding.subtitle": "حوّل الأجهزة الآمنة إلى لحظة علامة راقية عبر محافظ مشتركة محدودة ومواد إطلاق ودعم للحملة.",
    "coBranding.cta": "ابدأ مشروع تعاون مشترك",
    "coBranding.card.hardware": "الأجهزة",
    "coBranding.card.brandKit": "عدة العلامة",
    "coBranding.card.launch": "الإطلاق",
    "coBranding.card.packaging": "التغليف",
    "coBranding.card.campaign": "الحملة",
    "coBranding.card.retail": "التجزئة",
    "coBranding.card.creator": "صانع محتوى",
    "coBranding.card.event": "فعالية",
  },
  ja: {
    "partners.seoTitle": "LUKKEY パートナープログラム | アフィリエイトとリセラー",
    "partners.seoDescription": "アフィリエイト、クリエイター、リセラー、プロダクトパートナーとして LUKKEY に参加できます。",
    "partners.badge": "パートナープログラム",
    "partners.title": "LUKKEY と協業する。",
    "partners.programs.affiliate.title": "アフィリエイト",
    "partners.programs.affiliate.intro": "暗号資産セキュリティ領域のクリエイター、レビュアー、教育者、KOL ですか？",
    "partners.programs.affiliate.body": "LUKKEY に参加し、信頼できるセルフカストディ製品を紹介してパートナー報酬を獲得できます。",
    "partners.programs.affiliate.benefit1": "魅力的なコミッション",
    "partners.programs.affiliate.benefit2": "LUKKEY との直接的な関係",
    "partners.programs.affiliate.benefit3": "LUKKEY 最新情報への先行アクセス",
    "partners.programs.affiliate.cta": "LUKKEY アフィリエイトになる",
    "partners.programs.reseller.title": "リセラー",
    "partners.programs.reseller.intro": "自社サイト、店舗、チャネルで LUKKEY 製品を販売したいですか？",
    "partners.programs.reseller.body": "LUKKEY リセラープログラムに参加し、安全なハードウェアウォレットを顧客に届けましょう。",
    "partners.programs.reseller.benefit1": "優遇パートナー価格",
    "partners.programs.reseller.benefit2": "カスタマーサクセス支援",
    "partners.programs.reseller.benefit3": "共同マーケティングとローンチ計画",
    "partners.programs.reseller.cta": "LUKKEY リセラーになる",
    "coBranding.seoTitle": "LUKKEY 共同ブランド | パートナー協業",
    "coBranding.seoDescription": "LUKKEY の共同ブランド型ハードウェアウォレット施策、デザイン素材、パートナー向けローンチを実現します。",
    "coBranding.badge": "パートナー協業",
    "coBranding.title": "共同ブランド",
    "coBranding.subtitle": "限定共同ブランドウォレット、ローンチ素材、キャンペーン支援で、安全なハードウェアをプレミアムなブランド接点に変えます。",
    "coBranding.cta": "共同ブランドを始める",
    "coBranding.card.hardware": "ハードウェア",
    "coBranding.card.brandKit": "ブランドキット",
    "coBranding.card.launch": "ローンチ",
    "coBranding.card.packaging": "パッケージ",
    "coBranding.card.campaign": "キャンペーン",
    "coBranding.card.retail": "リテール",
    "coBranding.card.creator": "クリエイター",
    "coBranding.card.event": "イベント",
  },
  ru: {
    "partners.seoTitle": "Партнерские программы LUKKEY | Аффилиаты и реселлеры",
    "partners.seoDescription": "Присоединяйтесь к LUKKEY как аффилиат, автор, реселлер или продуктовый партнер.",
    "partners.badge": "Партнерские программы",
    "partners.title": "Работайте с LUKKEY.",
    "partners.programs.affiliate.title": "Аффилиат",
    "partners.programs.affiliate.intro": "Вы автор, обозреватель, преподаватель или KOL в сфере криптобезопасности?",
    "partners.programs.affiliate.body": "Присоединяйтесь к LUKKEY, продвигайте надежные self-custody продукты и получайте партнерские вознаграждения.",
    "partners.programs.affiliate.benefit1": "Привлекательные комиссии",
    "partners.programs.affiliate.benefit2": "Прямые отношения с LUKKEY",
    "partners.programs.affiliate.benefit3": "Ранний доступ к обновлениям LUKKEY",
    "partners.programs.affiliate.cta": "Стать аффилиатом LUKKEY",
    "partners.programs.reseller.title": "Реселлер",
    "partners.programs.reseller.intro": "Хотите продавать продукты LUKKEY через сайт, магазин или канал?",
    "partners.programs.reseller.body": "Присоединяйтесь к программе реселлеров LUKKEY и предлагайте клиентам безопасные аппаратные кошельки.",
    "partners.programs.reseller.benefit1": "Предпочтительные партнерские цены",
    "partners.programs.reseller.benefit2": "Поддержка customer success",
    "partners.programs.reseller.benefit3": "Совместный маркетинг и план запуска",
    "partners.programs.reseller.cta": "Стать реселлером LUKKEY",
    "coBranding.seoTitle": "Кобрендинг LUKKEY | Партнерское сотрудничество",
    "coBranding.seoDescription": "Создавайте кобрендинговые кампании аппаратных кошельков LUKKEY, дизайн-материалы и партнерские запуски.",
    "coBranding.badge": "Партнерское сотрудничество",
    "coBranding.title": "Кобрендинг",
    "coBranding.subtitle": "Превратите безопасное устройство в премиальный бренд-момент с лимитированными кобрендинговыми кошельками, launch assets и поддержкой кампании.",
    "coBranding.cta": "Запустить кобрендинг-проект",
    "coBranding.card.hardware": "Устройство",
    "coBranding.card.brandKit": "Бренд-кит",
    "coBranding.card.launch": "Запуск",
    "coBranding.card.packaging": "Упаковка",
    "coBranding.card.campaign": "Кампания",
    "coBranding.card.retail": "Ритейл",
    "coBranding.card.creator": "Автор",
    "coBranding.card.event": "Событие",
  },
  ko: {
    "partners.seoTitle": "LUKKEY 파트너 프로그램 | 제휴 및 리셀러",
    "partners.seoDescription": "제휴 파트너, 크리에이터, 리셀러 또는 제품 파트너로 LUKKEY와 함께하세요.",
    "partners.badge": "파트너 프로그램",
    "partners.title": "LUKKEY와 협업하세요.",
    "partners.programs.affiliate.title": "제휴",
    "partners.programs.affiliate.intro": "크립토 보안 분야의 크리에이터, 리뷰어, 교육자 또는 KOL인가요?",
    "partners.programs.affiliate.body": "LUKKEY에 참여해 신뢰할 수 있는 셀프 커스터디 제품을 소개하고 파트너 보상을 받으세요.",
    "partners.programs.affiliate.benefit1": "매력적인 커미션",
    "partners.programs.affiliate.benefit2": "LUKKEY와의 직접적인 관계",
    "partners.programs.affiliate.benefit3": "LUKKEY 업데이트 선공개",
    "partners.programs.affiliate.cta": "LUKKEY 제휴 파트너 되기",
    "partners.programs.reseller.title": "리셀러",
    "partners.programs.reseller.intro": "웹사이트, 매장 또는 채널에서 LUKKEY 제품을 판매하고 싶으신가요?",
    "partners.programs.reseller.body": "LUKKEY 리셀러 프로그램에 참여해 고객에게 안전한 하드웨어 지갑을 제공하세요.",
    "partners.programs.reseller.benefit1": "우대 파트너 가격",
    "partners.programs.reseller.benefit2": "고객 성공 지원",
    "partners.programs.reseller.benefit3": "공동 마케팅 및 출시 계획",
    "partners.programs.reseller.cta": "LUKKEY 리셀러 되기",
    "coBranding.seoTitle": "LUKKEY 공동 브랜딩 | 파트너 협업",
    "coBranding.seoDescription": "LUKKEY 공동 브랜딩 하드웨어 지갑 캠페인, 디자인 자산, 파트너 출시를 만드세요.",
    "coBranding.badge": "파트너 협업",
    "coBranding.title": "공동 브랜딩",
    "coBranding.subtitle": "한정 공동 브랜딩 지갑, 출시 자산, 캠페인 지원으로 안전한 하드웨어를 프리미엄 브랜드 접점으로 만드세요.",
    "coBranding.cta": "공동 브랜딩 시작",
    "coBranding.card.hardware": "하드웨어",
    "coBranding.card.brandKit": "브랜드 키트",
    "coBranding.card.launch": "출시",
    "coBranding.card.packaging": "패키징",
    "coBranding.card.campaign": "캠페인",
    "coBranding.card.retail": "리테일",
    "coBranding.card.creator": "크리에이터",
    "coBranding.card.event": "이벤트",
  },
});

partnerPageLocaleTranslations.pt = {
  "partners.seoTitle": "Programas de parceiros LUKKEY | Afiliados e revendedores",
  "partners.seoDescription": "Junte-se à LUKKEY como afiliado, criador, revendedor ou parceiro de produto.",
  "partners.badge": "Programas de parceiros",
  "partners.title": "Trabalhe com a LUKKEY.",
  "partners.programs.affiliate.title": "Afiliado",
  "partners.programs.affiliate.intro": "Você é criador, reviewer, educador ou KOL no espaço de segurança cripto?",
  "partners.programs.affiliate.body": "Junte-se à LUKKEY, promova produtos self-custody confiáveis e ganhe recompensas de parceiro.",
  "partners.programs.affiliate.benefit1": "Comissões atrativas",
  "partners.programs.affiliate.benefit2": "Relacionamento direto com a LUKKEY",
  "partners.programs.affiliate.benefit3": "Acesso antecipado a novidades da LUKKEY",
  "partners.programs.affiliate.cta": "Tornar-se afiliado LUKKEY",
  "partners.programs.reseller.title": "Revendedor",
  "partners.programs.reseller.intro": "Quer vender produtos LUKKEY pelo seu site, loja ou canal?",
  "partners.programs.reseller.body": "Entre no programa de revendedores LUKKEY e leve carteiras de hardware seguras aos seus clientes.",
  "partners.programs.reseller.benefit1": "Preço preferencial para parceiros",
  "partners.programs.reseller.benefit2": "Suporte de customer success",
  "partners.programs.reseller.benefit3": "Co-marketing e planejamento de lançamento",
  "partners.programs.reseller.cta": "Tornar-se revendedor LUKKEY",
  "coBranding.seoTitle": "Co-branding LUKKEY | Colaboração de parceiros",
  "coBranding.seoDescription": "Crie campanhas de carteiras de hardware co-branded LUKKEY, assets de design e lançamentos com parceiros.",
  "coBranding.badge": "Colaboração de parceiros",
  "coBranding.title": "Co-branding",
  "coBranding.subtitle": "Transforme hardware seguro em um momento premium de marca com carteiras co-branded limitadas, assets de lançamento e suporte de campanha.",
  "coBranding.cta": "Iniciar projeto de co-branding",
  "coBranding.card.hardware": "Hardware",
  "coBranding.card.brandKit": "Kit de marca",
  "coBranding.card.launch": "Lançamento",
  "coBranding.card.packaging": "Embalagem",
  "coBranding.card.campaign": "Campanha",
  "coBranding.card.retail": "Varejo",
  "coBranding.card.creator": "Criador",
  "coBranding.card.event": "Evento",
};

partnerPageLocaleTranslations["pt-BR"] = partnerPageLocaleTranslations.pt;

Object.assign(partnerPageLocaleTranslations, {
  it: {
    "partners.seoTitle": "Programmi partner LUKKEY | Affiliate e rivenditori",
    "partners.seoDescription": "Unisciti a LUKKEY come affiliate, creator, rivenditore o partner di prodotto.",
    "partners.badge": "Programmi partner",
    "partners.title": "Lavora con LUKKEY.",
    "partners.programs.affiliate.title": "Affiliate",
    "partners.programs.affiliate.intro": "Sei un creator, reviewer, educator o KOL nel settore della sicurezza crypto?",
    "partners.programs.affiliate.body": "Unisciti a LUKKEY, promuovi prodotti self-custody affidabili e ottieni reward da partner.",
    "partners.programs.affiliate.benefit1": "Commissioni interessanti",
    "partners.programs.affiliate.benefit2": "Relazione diretta con LUKKEY",
    "partners.programs.affiliate.benefit3": "Accesso anticipato agli aggiornamenti LUKKEY",
    "partners.programs.affiliate.cta": "Diventa affiliate LUKKEY",
    "partners.programs.reseller.title": "Rivenditore",
    "partners.programs.reseller.intro": "Vuoi vendere prodotti LUKKEY tramite il tuo sito, negozio o canale?",
    "partners.programs.reseller.body": "Entra nel programma rivenditori LUKKEY e porta wallet hardware sicuri ai tuoi clienti.",
    "partners.programs.reseller.benefit1": "Prezzi partner preferenziali",
    "partners.programs.reseller.benefit2": "Supporto customer success",
    "partners.programs.reseller.benefit3": "Co-marketing e pianificazione del lancio",
    "partners.programs.reseller.cta": "Diventa rivenditore LUKKEY",
    "coBranding.seoTitle": "Co-branding LUKKEY | Collaborazione partner",
    "coBranding.seoDescription": "Crea campagne di wallet hardware co-branded LUKKEY, asset di design e lanci con partner.",
    "coBranding.badge": "Collaborazione partner",
    "coBranding.title": "Co-branding",
    "coBranding.subtitle": "Trasforma l'hardware sicuro in un momento premium di marca con wallet co-branded limitati, asset di lancio e supporto campagna.",
    "coBranding.cta": "Avvia un progetto co-branding",
    "coBranding.card.hardware": "Hardware",
    "coBranding.card.brandKit": "Brand kit",
    "coBranding.card.launch": "Lancio",
    "coBranding.card.packaging": "Packaging",
    "coBranding.card.campaign": "Campagna",
    "coBranding.card.retail": "Retail",
    "coBranding.card.creator": "Creator",
    "coBranding.card.event": "Evento",
  },
  de: {
    "partners.seoTitle": "LUKKEY Partnerprogramme | Affiliate und Reseller",
    "partners.seoDescription": "Werden Sie LUKKEY Affiliate, Creator, Reseller oder Produktpartner.",
    "partners.badge": "Partnerprogramme",
    "partners.title": "Arbeiten Sie mit LUKKEY.",
    "partners.programs.affiliate.title": "Affiliate",
    "partners.programs.affiliate.intro": "Sind Sie Creator, Reviewer, Educator oder KOL im Bereich Krypto-Sicherheit?",
    "partners.programs.affiliate.body": "Werden Sie LUKKEY Partner, bewerben Sie vertrauenswürdige Self-Custody-Produkte und verdienen Sie Partnerprämien.",
    "partners.programs.affiliate.benefit1": "Attraktive Provisionen",
    "partners.programs.affiliate.benefit2": "Direkte Beziehung zu LUKKEY",
    "partners.programs.affiliate.benefit3": "Früher Zugang zu LUKKEY Updates",
    "partners.programs.affiliate.cta": "LUKKEY Affiliate werden",
    "partners.programs.reseller.title": "Reseller",
    "partners.programs.reseller.intro": "Möchten Sie LUKKEY Produkte über Ihre Website, Ihren Shop oder Kanal verkaufen?",
    "partners.programs.reseller.body": "Nehmen Sie am LUKKEY Reseller-Programm teil und bringen Sie sichere Hardware-Wallets zu Ihren Kunden.",
    "partners.programs.reseller.benefit1": "Bevorzugte Partnerpreise",
    "partners.programs.reseller.benefit2": "Customer-Success-Support",
    "partners.programs.reseller.benefit3": "Co-Marketing und Launch-Planung",
    "partners.programs.reseller.cta": "LUKKEY Reseller werden",
    "coBranding.seoTitle": "LUKKEY Co-Branding | Partnerkooperation",
    "coBranding.seoDescription": "Erstellen Sie co-gebrandete LUKKEY Hardware-Wallet-Kampagnen, Design-Assets und Partner-Launches.",
    "coBranding.badge": "Partnerkooperation",
    "coBranding.title": "Co-Branding",
    "coBranding.subtitle": "Machen Sie sichere Hardware mit limitierten Co-Branding-Wallets, Launch-Assets und Kampagnenunterstützung zu einem Premium-Markenmoment.",
    "coBranding.cta": "Co-Branding-Projekt starten",
    "coBranding.card.hardware": "Hardware",
    "coBranding.card.brandKit": "Brand Kit",
    "coBranding.card.launch": "Launch",
    "coBranding.card.packaging": "Packaging",
    "coBranding.card.campaign": "Kampagne",
    "coBranding.card.retail": "Retail",
    "coBranding.card.creator": "Creator",
    "coBranding.card.event": "Event",
  },
  hi: {
    "partners.seoTitle": "LUKKEY पार्टनर प्रोग्राम | एफिलिएट और रीसेलर",
    "partners.seoDescription": "एफिलिएट, क्रिएटर, रीसेलर या प्रोडक्ट पार्टनर के रूप में LUKKEY से जुड़ें।",
    "partners.badge": "पार्टनर प्रोग्राम",
    "partners.title": "LUKKEY के साथ काम करें।",
    "partners.programs.affiliate.title": "एफिलिएट",
    "partners.programs.affiliate.intro": "क्या आप क्रिप्टो सुरक्षा क्षेत्र में क्रिएटर, रिव्यूअर, एजुकेटर या KOL हैं?",
    "partners.programs.affiliate.body": "LUKKEY से जुड़ें, भरोसेमंद self-custody उत्पादों को प्रमोट करें और पार्टनर रिवॉर्ड पाएं।",
    "partners.programs.affiliate.benefit1": "आकर्षक कमीशन",
    "partners.programs.affiliate.benefit2": "LUKKEY के साथ सीधा संबंध",
    "partners.programs.affiliate.benefit3": "LUKKEY अपडेट्स का शुरुआती एक्सेस",
    "partners.programs.affiliate.cta": "LUKKEY एफिलिएट बनें",
    "partners.programs.reseller.title": "रीसेलर",
    "partners.programs.reseller.intro": "क्या आप अपनी वेबसाइट, दुकान या चैनल पर LUKKEY उत्पाद बेचना चाहते हैं?",
    "partners.programs.reseller.body": "LUKKEY रीसेलर प्रोग्राम से जुड़ें और अपने ग्राहकों तक सुरक्षित हार्डवेयर वॉलेट पहुंचाएं।",
    "partners.programs.reseller.benefit1": "प्रेफर्ड पार्टनर प्राइसिंग",
    "partners.programs.reseller.benefit2": "कस्टमर सक्सेस सपोर्ट",
    "partners.programs.reseller.benefit3": "को-मार्केटिंग और लॉन्च प्लानिंग",
    "partners.programs.reseller.cta": "LUKKEY रीसेलर बनें",
    "coBranding.seoTitle": "LUKKEY को-ब्रांडिंग | पार्टनर सहयोग",
    "coBranding.seoDescription": "LUKKEY को-ब्रांडेड हार्डवेयर वॉलेट कैंपेन, डिजाइन assets और पार्टनर लॉन्च बनाएं।",
    "coBranding.badge": "पार्टनर सहयोग",
    "coBranding.title": "को-ब्रांडिंग",
    "coBranding.subtitle": "लिमिटेड को-ब्रांडेड वॉलेट, लॉन्च assets और कैंपेन सपोर्ट से सुरक्षित हार्डवेयर को प्रीमियम ब्रांड मोमेंट बनाएं।",
    "coBranding.cta": "को-ब्रांडिंग प्रोजेक्ट शुरू करें",
    "coBranding.card.hardware": "हार्डवेयर",
    "coBranding.card.brandKit": "ब्रांड किट",
    "coBranding.card.launch": "लॉन्च",
    "coBranding.card.packaging": "पैकेजिंग",
    "coBranding.card.campaign": "कैंपेन",
    "coBranding.card.retail": "रिटेल",
    "coBranding.card.creator": "क्रिएटर",
    "coBranding.card.event": "इवेंट",
  },
  mn: {
    "partners.seoTitle": "LUKKEY түншлэлийн хөтөлбөрүүд | Affiliate ба reseller",
    "partners.seoDescription": "Affiliate, creator, reseller эсвэл бүтээгдэхүүний түншээр LUKKEY-тэй нэгдээрэй.",
    "partners.badge": "Түншлэлийн хөтөлбөрүүд",
    "partners.title": "LUKKEY-тэй хамтран ажилла.",
    "partners.programs.affiliate.title": "Affiliate",
    "partners.programs.affiliate.intro": "Та крипто аюулгүй байдлын creator, reviewer, educator эсвэл KOL мөн үү?",
    "partners.programs.affiliate.body": "LUKKEY-тэй нэгдэж, найдвартай self-custody бүтээгдэхүүнийг сурталчилж түншийн урамшуулал аваарай.",
    "partners.programs.affiliate.benefit1": "Сонирхолтой шимтгэл",
    "partners.programs.affiliate.benefit2": "LUKKEY-тэй шууд харилцаа",
    "partners.programs.affiliate.benefit3": "LUKKEY шинэчлэлтэд түрүүлж хандах",
    "partners.programs.affiliate.cta": "LUKKEY affiliate болох",
    "partners.programs.reseller.title": "Reseller",
    "partners.programs.reseller.intro": "Та өөрийн сайт, дэлгүүр эсвэл сувгаар LUKKEY бүтээгдэхүүн борлуулахыг хүсэж байна уу?",
    "partners.programs.reseller.body": "LUKKEY reseller хөтөлбөрт нэгдэж, аюулгүй hardware wallet-ыг хэрэглэгчдэдээ хүргээрэй.",
    "partners.programs.reseller.benefit1": "Түншийн давуу үнэ",
    "partners.programs.reseller.benefit2": "Customer success дэмжлэг",
    "partners.programs.reseller.benefit3": "Хамтарсан маркетинг ба нээлтийн төлөвлөлт",
    "partners.programs.reseller.cta": "LUKKEY reseller болох",
    "coBranding.seoTitle": "LUKKEY хамтарсан брэнд | Түншийн хамтын ажиллагаа",
    "coBranding.seoDescription": "LUKKEY хамтарсан брэндийн hardware wallet кампанит ажил, дизайны материал болон түншийн нээлт бүтээ.",
    "coBranding.badge": "Түншийн хамтын ажиллагаа",
    "coBranding.title": "Хамтарсан брэнд",
    "coBranding.subtitle": "Хязгаарлагдмал хамтарсан брэндийн wallet, launch assets болон кампанит ажлын дэмжлэгээр аюулгүй hardware-ыг премиум брэндийн мөч болго.",
    "coBranding.cta": "Хамтарсан брэндийн төсөл эхлүүлэх",
    "coBranding.card.hardware": "Hardware",
    "coBranding.card.brandKit": "Брэнд кит",
    "coBranding.card.launch": "Нээлт",
    "coBranding.card.packaging": "Сав баглаа",
    "coBranding.card.campaign": "Кампанит ажил",
    "coBranding.card.retail": "Retail",
    "coBranding.card.creator": "Creator",
    "coBranding.card.event": "Event",
  },
  th: {
    "partners.seoTitle": "โปรแกรมพาร์ทเนอร์ LUKKEY | Affiliate และ Reseller",
    "partners.seoDescription": "ร่วมงานกับ LUKKEY ในฐานะ affiliate, creator, reseller หรือ product partner",
    "partners.badge": "โปรแกรมพาร์ทเนอร์",
    "partners.title": "ร่วมงานกับ LUKKEY",
    "partners.programs.affiliate.title": "Affiliate",
    "partners.programs.affiliate.intro": "คุณเป็น creator, reviewer, educator หรือ KOL ด้านความปลอดภัยคริปโตหรือไม่?",
    "partners.programs.affiliate.body": "เข้าร่วม LUKKEY โปรโมตผลิตภัณฑ์ self-custody ที่น่าเชื่อถือ และรับรางวัลพาร์ทเนอร์",
    "partners.programs.affiliate.benefit1": "คอมมิชชันน่าสนใจ",
    "partners.programs.affiliate.benefit2": "ความสัมพันธ์โดยตรงกับ LUKKEY",
    "partners.programs.affiliate.benefit3": "เข้าถึงอัปเดต LUKKEY ก่อนใคร",
    "partners.programs.affiliate.cta": "เป็น LUKKEY affiliate",
    "partners.programs.reseller.title": "Reseller",
    "partners.programs.reseller.intro": "คุณต้องการขายผลิตภัณฑ์ LUKKEY ผ่านเว็บไซต์ ร้านค้า หรือช่องทางของคุณหรือไม่?",
    "partners.programs.reseller.body": "เข้าร่วมโปรแกรม reseller ของ LUKKEY และนำ hardware wallet ที่ปลอดภัยไปสู่ลูกค้าของคุณ",
    "partners.programs.reseller.benefit1": "ราคาพาร์ทเนอร์พิเศษ",
    "partners.programs.reseller.benefit2": "การสนับสนุน customer success",
    "partners.programs.reseller.benefit3": "Co-marketing และการวางแผนเปิดตัว",
    "partners.programs.reseller.cta": "เป็น LUKKEY reseller",
    "coBranding.seoTitle": "LUKKEY Co-branding | ความร่วมมือพาร์ทเนอร์",
    "coBranding.seoDescription": "สร้างแคมเปญ hardware wallet แบบ co-branded ของ LUKKEY, design assets และการเปิดตัวร่วมกับพาร์ทเนอร์",
    "coBranding.badge": "ความร่วมมือพาร์ทเนอร์",
    "coBranding.title": "โคแบรนด์",
    "coBranding.subtitle": "เปลี่ยน hardware ที่ปลอดภัยให้เป็น premium brand moment ด้วย wallet co-branded รุ่นจำกัด launch assets และการสนับสนุนแคมเปญ",
    "coBranding.cta": "เริ่มโปรเจกต์โคแบรนด์",
    "coBranding.card.hardware": "Hardware",
    "coBranding.card.brandKit": "Brand kit",
    "coBranding.card.launch": "Launch",
    "coBranding.card.packaging": "Packaging",
    "coBranding.card.campaign": "Campaign",
    "coBranding.card.retail": "Retail",
    "coBranding.card.creator": "Creator",
    "coBranding.card.event": "Event",
  },
});

export const partnerTranslations = {
  en: {
    "partners.seoTitle": "LUKKEY Partner Programs | Affiliate and Reseller",
    "partners.seoDescription":
      "Join LUKKEY as an affiliate, creator, reseller, or product partner.",
    "partners.badge": "Partner Programs",
    "partners.title": "Work with LUKKEY.",
    "partners.contactPrefix": "Contact us",
    "partners.contactBody":
      "and our customer success team will share the right program details.",
    "partners.programs.affiliate.title": "Affiliate",
    "partners.programs.affiliate.intro":
      "Are you a creator, reviewer, educator, or KOL in the crypto security space?",
    "partners.programs.affiliate.body":
      "Join LUKKEY, promote trusted self-custody products, and earn partner rewards.",
    "partners.programs.affiliate.benefit1": "Attractive commissions",
    "partners.programs.affiliate.benefit2": "Direct relationship with LUKKEY",
    "partners.programs.affiliate.benefit3": "Early access to LUKKEY updates",
    "partners.programs.affiliate.cta": "Become a LUKKEY affiliate",
    "partners.programs.reseller.title": "Reseller",
    "partners.programs.reseller.intro":
      "Do you want to sell LUKKEY products through your website, shop, or channel?",
    "partners.programs.reseller.body":
      "Join the LUKKEY reseller program and bring secure hardware wallets to your customers.",
    "partners.programs.reseller.benefit1": "Preferred partner pricing",
    "partners.programs.reseller.benefit2": "Customer success support",
    "partners.programs.reseller.benefit3": "Co-marketing and launch planning",
    "partners.programs.reseller.cta": "Become a LUKKEY reseller",
    "coBranding.seoTitle": "LUKKEY Co-branding | Partner Collaboration",
    "coBranding.seoDescription":
      "Create co-branded LUKKEY hardware wallet campaigns, design assets, and partner launches.",
    "coBranding.badge": "Partner Collaboration",
    "coBranding.title": "Co-branding",
    "coBranding.subtitle":
      "Turn secure hardware into a premium brand moment with limited co-branded wallets, launch assets, and campaign support.",
    "coBranding.cta": "Start a co-branding project",
    "coBranding.card.hardware": "Hardware",
    "coBranding.card.brandKit": "Brand kit",
    "coBranding.card.launch": "Launch",
    "coBranding.card.packaging": "Packaging",
    "coBranding.card.campaign": "Campaign",
    "coBranding.card.retail": "Retail",
    "coBranding.card.creator": "Creator",
    "coBranding.card.event": "Event",
    "partnerInquiry.seoTitle": "LUKKEY Partner Inquiry | Apply to Work with LUKKEY",
    "partnerInquiry.seoDescription":
      "Apply for affiliate, reseller, or co-branding collaboration with LUKKEY.",
    "partnerInquiry.badge": "Partner inquiry",
    "partnerInquiry.title": "Tell us how you want to work with LUKKEY.",
    "partnerInquiry.subtitle":
      "This is a business collaboration intake, separate from customer support.",
    "partnerInquiry.point1": "Routed to the right partnership owner",
    "partnerInquiry.point2": "Pre-filled by collaboration type",
    "partnerInquiry.point3": "Follow-up by email from the LUKKEY team",
    "partnerInquiry.program.affiliate": "Affiliate",
    "partnerInquiry.program.reseller": "Reseller",
    "partnerInquiry.program.cobranding": "Co-branding",
    "partnerInquiry.affiliate.seoTitle": "LUKKEY Affiliate Application | Creator Program",
    "partnerInquiry.affiliate.seoDescription":
      "Apply to join LUKKEY as a creator or affiliate partner.",
    "partnerInquiry.affiliate.badge": "Creator affiliate",
    "partnerInquiry.affiliate.title": "Join LUKKEY as a creator partner.",
    "partnerInquiry.affiliate.subtitle":
      "A quick, friendly application for creators, reviewers, educators, and community builders.",
    "partnerInquiry.affiliate.point1": "Simple creator-friendly application",
    "partnerInquiry.affiliate.point2": "Share your channel and audience fit",
    "partnerInquiry.affiliate.point3": "Get a follow-up from the LUKKEY team",
    "partnerInquiry.affiliate.messageLabel": "Tell us about your content",
    "partnerInquiry.affiliate.submit": "Apply as a creator partner",
    "partnerInquiry.affiliate.success": "Your creator partner application has been sent.",
    "partnerInquiry.reseller.seoTitle": "LUKKEY Reseller Application | Business Partnership",
    "partnerInquiry.reseller.seoDescription":
      "Apply to become a LUKKEY reseller or sales channel partner.",
    "partnerInquiry.reseller.badge": "Reseller application",
    "partnerInquiry.reseller.title": "Apply to become a LUKKEY reseller.",
    "partnerInquiry.reseller.subtitle":
      "A concise business intake for stores, distributors, and sales channels.",
    "partnerInquiry.reseller.point1": "Business profile and sales region",
    "partnerInquiry.reseller.point2": "Channel fit and expected volume",
    "partnerInquiry.reseller.point3": "Professional follow-up from partnership sales",
    "partnerInquiry.reseller.messageLabel": "Business requirements",
    "partnerInquiry.reseller.submit": "Submit reseller application",
    "partnerInquiry.reseller.success": "Your reseller application has been sent.",
    "partnerInquiry.cobranding.seoTitle": "LUKKEY Co-branding Inquiry | Brand Collaboration",
    "partnerInquiry.cobranding.seoDescription":
      "Start a LUKKEY co-branding collaboration inquiry.",
    "partnerInquiry.cobranding.badge": "Brand collaboration",
    "partnerInquiry.cobranding.title": "Start a co-branding conversation.",
    "partnerInquiry.cobranding.subtitle":
      "A focused business intake for campaign, product, and launch collaboration.",
    "partnerInquiry.cobranding.point1": "Brand, campaign, and launch context",
    "partnerInquiry.cobranding.point2": "Design or product requirements",
    "partnerInquiry.cobranding.point3": "Reviewed by the LUKKEY partnership team",
    "partnerInquiry.cobranding.messageLabel": "Collaboration brief",
    "partnerInquiry.cobranding.submit": "Submit co-branding inquiry",
    "partnerInquiry.cobranding.success": "Your co-branding inquiry has been sent.",
    "partnerInquiry.form.name": "Name",
    "partnerInquiry.form.email": "Email",
    "partnerInquiry.form.company": "Company / channel",
    "partnerInquiry.form.website": "Website or social link",
    "partnerInquiry.form.channel": "Main channel or social link",
    "partnerInquiry.form.audience": "Audience or community",
    "partnerInquiry.form.region": "Sales region",
    "partnerInquiry.form.volume": "Expected monthly volume",
    "partnerInquiry.form.timeline": "Target launch timing",
    "partnerInquiry.form.program": "Collaboration type",
    "partnerInquiry.form.message": "Collaboration details",
    "partnerInquiry.form.submit": "Submit partner inquiry",
    "partnerInquiry.form.submitting": "Submitting",
    "partnerInquiry.validation.required": "This field is required.",
    "partnerInquiry.validation.email": "Enter a valid email address.",
    "partnerInquiry.success": "Your partner inquiry has been sent. We will follow up by email.",
    "partnerInquiry.error": "There was an error submitting your inquiry.",
    "partnerInquiry.prefill.affiliate":
      "I would like to apply for the LUKKEY affiliate program.\n\nChannel / audience:\nRegion:\nExpected collaboration format:\nRelevant links:",
    "partnerInquiry.prefill.reseller":
      "I would like to apply for the LUKKEY reseller program.\n\nCompany / store name:\nSales channels:\nRegion:\nExpected monthly volume:\nRelevant links:",
    "partnerInquiry.prefill.cobranding":
      "I would like to discuss a LUKKEY co-branding collaboration.\n\nBrand / project:\nCampaign idea:\nTarget launch timing:\nDesign or product requirements:\nRelevant links:",
  },
  zh: {
    "partners.seoTitle": "LUKKEY 合作伙伴计划 | 推荐返佣与经销商",
    "partners.seoDescription":
      "成为 LUKKEY 推荐合作伙伴、内容创作者、经销商或产品合作伙伴。",
    "partners.badge": "合作伙伴计划",
    "partners.title": "与 LUKKEY 合作。",
    "partners.contactPrefix": "联系我们",
    "partners.contactBody": "由客户成功团队为您介绍合适的计划详情。",
    "partners.programs.affiliate.title": "推荐返佣",
    "partners.programs.affiliate.intro":
      "你是 TikToker、YouTuber、测评博主，还是加密安全领域的 KOL？",
    "partners.programs.affiliate.body":
      "成为 LUKKEY 合作伙伴，推广可信赖的自托管产品并获得奖励。",
    "partners.programs.affiliate.benefit1": "有吸引力的佣金",
    "partners.programs.affiliate.benefit2": "与 LUKKEY 建立直接联系",
    "partners.programs.affiliate.benefit3": "抢先获取 LUKKEY 最新动态",
    "partners.programs.affiliate.cta": "成为 LUKKEY 会员",
    "partners.programs.reseller.title": "经销商",
    "partners.programs.reseller.intro":
      "您想在自己的网站、商店或渠道上销售 LUKKEY 产品吗？",
    "partners.programs.reseller.body":
      "加入 LUKKEY 经销商计划，把安全硬件钱包带给您的客户。",
    "partners.programs.reseller.benefit1": "获得最优惠的价格",
    "partners.programs.reseller.benefit2": "客户成功专家支持",
    "partners.programs.reseller.benefit3": "协助联名合作外观设计和促销策划",
    "partners.programs.reseller.cta": "成为 LUKKEY 经销商",
    "coBranding.seoTitle": "LUKKEY 联名合作 | 合作伙伴项目",
    "coBranding.seoDescription":
      "与 LUKKEY 一起打造联名硬件钱包活动、设计资料与合作发布。",
    "coBranding.badge": "合作伙伴项目",
    "coBranding.title": "联名合作",
    "coBranding.subtitle":
      "把安全硬件变成高端品牌触点，用限量联名钱包、发布素材和活动支持制造品牌溢价。",
    "coBranding.cta": "发起联名合作",
    "coBranding.card.hardware": "硬件",
    "coBranding.card.brandKit": "品牌资料",
    "coBranding.card.launch": "发布",
    "coBranding.card.packaging": "包装",
    "coBranding.card.campaign": "活动",
    "coBranding.card.retail": "零售",
    "coBranding.card.creator": "创作者",
    "coBranding.card.event": "线下活动",
    "partnerInquiry.seoTitle": "LUKKEY 合作申请 | 与 LUKKEY 合作",
    "partnerInquiry.seoDescription":
      "申请 LUKKEY 推荐返佣、经销商或联名合作项目。",
    "partnerInquiry.badge": "合作申请",
    "partnerInquiry.title": "告诉我们你想如何与 LUKKEY 合作。",
    "partnerInquiry.subtitle":
      "这是商务合作入口，和客户支持请求分开处理。",
    "partnerInquiry.point1": "分配给对应的合作负责人",
    "partnerInquiry.point2": "根据合作类型自动预填模板",
    "partnerInquiry.point3": "LUKKEY 团队将通过邮件跟进",
    "partnerInquiry.program.affiliate": "推荐返佣",
    "partnerInquiry.program.reseller": "经销商",
    "partnerInquiry.program.cobranding": "联名合作",
    "partnerInquiry.affiliate.seoTitle": "LUKKEY 推荐返佣申请 | 创作者合作",
    "partnerInquiry.affiliate.seoDescription":
      "申请成为 LUKKEY 创作者或推荐合作伙伴。",
    "partnerInquiry.affiliate.badge": "创作者推荐合作",
    "partnerInquiry.affiliate.title": "成为 LUKKEY 创作者合作伙伴。",
    "partnerInquiry.affiliate.subtitle":
      "面向创作者、测评博主、教育内容和社区运营者的轻量申请流程。",
    "partnerInquiry.affiliate.point1": "申请流程简单友好",
    "partnerInquiry.affiliate.point2": "说明你的渠道和受众匹配度",
    "partnerInquiry.affiliate.point3": "LUKKEY 团队会通过邮件跟进",
    "partnerInquiry.affiliate.messageLabel": "介绍你的内容方向",
    "partnerInquiry.affiliate.submit": "提交创作者合作申请",
    "partnerInquiry.affiliate.success": "创作者合作申请已发送。",
    "partnerInquiry.reseller.seoTitle": "LUKKEY 经销商申请 | 商务合作",
    "partnerInquiry.reseller.seoDescription":
      "申请成为 LUKKEY 经销商或销售渠道合作伙伴。",
    "partnerInquiry.reseller.badge": "经销商申请",
    "partnerInquiry.reseller.title": "申请成为 LUKKEY 经销商。",
    "partnerInquiry.reseller.subtitle":
      "面向商店、分销商和销售渠道的简洁商务线索流程。",
    "partnerInquiry.reseller.point1": "收集公司信息和销售地区",
    "partnerInquiry.reseller.point2": "确认渠道匹配度和预计销量",
    "partnerInquiry.reseller.point3": "由合作销售团队专业跟进",
    "partnerInquiry.reseller.messageLabel": "商务需求",
    "partnerInquiry.reseller.submit": "提交经销商申请",
    "partnerInquiry.reseller.success": "经销商申请已发送。",
    "partnerInquiry.cobranding.seoTitle": "LUKKEY 联名合作咨询 | 品牌合作",
    "partnerInquiry.cobranding.seoDescription":
      "发起 LUKKEY 联名合作咨询。",
    "partnerInquiry.cobranding.badge": "品牌联名合作",
    "partnerInquiry.cobranding.title": "发起一次联名合作沟通。",
    "partnerInquiry.cobranding.subtitle":
      "面向活动、产品和发布合作的专业商务入口。",
    "partnerInquiry.cobranding.point1": "说明品牌、活动和发布时间",
    "partnerInquiry.cobranding.point2": "整理设计或产品需求",
    "partnerInquiry.cobranding.point3": "由 LUKKEY 合作团队评估跟进",
    "partnerInquiry.cobranding.messageLabel": "合作简报",
    "partnerInquiry.cobranding.submit": "提交联名合作咨询",
    "partnerInquiry.cobranding.success": "联名合作咨询已发送。",
    "partnerInquiry.form.name": "姓名",
    "partnerInquiry.form.email": "邮箱",
    "partnerInquiry.form.company": "公司 / 渠道",
    "partnerInquiry.form.website": "网站或社交链接",
    "partnerInquiry.form.channel": "主要渠道或社交链接",
    "partnerInquiry.form.audience": "受众或社区",
    "partnerInquiry.form.region": "销售地区",
    "partnerInquiry.form.volume": "预计月销量",
    "partnerInquiry.form.timeline": "目标上线时间",
    "partnerInquiry.form.program": "合作类型",
    "partnerInquiry.form.message": "合作详情",
    "partnerInquiry.form.submit": "提交合作申请",
    "partnerInquiry.form.submitting": "正在提交",
    "partnerInquiry.validation.required": "此字段为必填项。",
    "partnerInquiry.validation.email": "请输入有效邮箱地址。",
    "partnerInquiry.success": "合作申请已发送，我们会通过邮件跟进。",
    "partnerInquiry.error": "提交失败，请稍后再试。",
    "partnerInquiry.prefill.affiliate":
      "我想申请 LUKKEY 推荐返佣合作计划。\n\n渠道 / 受众：\n所在地区：\n期望合作形式：\n相关链接：",
    "partnerInquiry.prefill.reseller":
      "我想申请 LUKKEY 经销商合作计划。\n\n公司 / 店铺名称：\n销售渠道：\n所在地区：\n预计月销量：\n相关链接：",
    "partnerInquiry.prefill.cobranding":
      "我想沟通 LUKKEY 联名合作。\n\n品牌 / 项目名称：\n活动想法：\n目标上线时间：\n设计或产品需求：\n相关链接：",
  },
  "zh-TW": {
    "partners.seoTitle": "LUKKEY 合作夥伴計畫 | 推薦返佣與經銷商",
    "partners.seoDescription":
      "成為 LUKKEY 推薦合作夥伴、內容創作者、經銷商或產品合作夥伴。",
    "partners.badge": "合作夥伴計畫",
    "partners.title": "與 LUKKEY 合作。",
    "partners.contactPrefix": "聯絡我們",
    "partners.contactBody": "由客戶成功團隊為您介紹合適的計畫詳情。",
    "partners.programs.affiliate.title": "推薦返佣",
    "partners.programs.affiliate.intro":
      "你是 TikToker、YouTuber、測評創作者，還是加密安全領域的 KOL？",
    "partners.programs.affiliate.body":
      "成為 LUKKEY 合作夥伴，推廣可信賴的自託管產品並獲得獎勵。",
    "partners.programs.affiliate.benefit1": "有吸引力的佣金",
    "partners.programs.affiliate.benefit2": "與 LUKKEY 建立直接聯繫",
    "partners.programs.affiliate.benefit3": "搶先獲取 LUKKEY 最新動態",
    "partners.programs.affiliate.cta": "成為 LUKKEY 會員",
    "partners.programs.reseller.title": "經銷商",
    "partners.programs.reseller.intro":
      "您想在自己的網站、商店或通路上銷售 LUKKEY 產品嗎？",
    "partners.programs.reseller.body":
      "加入 LUKKEY 經銷商計畫，把安全硬體錢包帶給您的客戶。",
    "partners.programs.reseller.benefit1": "獲得最優惠的價格",
    "partners.programs.reseller.benefit2": "客戶成功專家支援",
    "partners.programs.reseller.benefit3": "協助聯名外觀設計與促銷策劃",
    "partners.programs.reseller.cta": "成為 LUKKEY 經銷商",
    "coBranding.seoTitle": "LUKKEY 聯名合作 | 合作夥伴專案",
    "coBranding.seoDescription":
      "與 LUKKEY 一起打造聯名硬體錢包活動、設計資料與合作發布。",
    "coBranding.badge": "合作夥伴專案",
    "coBranding.title": "聯名合作",
    "coBranding.subtitle":
      "把安全硬體變成高端品牌觸點，用限量聯名錢包、發布素材和活動支援製造品牌溢價。",
    "coBranding.cta": "發起聯名合作",
    "coBranding.card.hardware": "硬體",
    "coBranding.card.brandKit": "品牌資料",
    "coBranding.card.launch": "發布",
    "coBranding.card.packaging": "包裝",
    "coBranding.card.campaign": "活動",
    "coBranding.card.retail": "零售",
    "coBranding.card.creator": "創作者",
    "coBranding.card.event": "線下活動",
    "partnerInquiry.seoTitle": "LUKKEY 合作申請 | 與 LUKKEY 合作",
    "partnerInquiry.seoDescription":
      "申請 LUKKEY 推薦返佣、經銷商或聯名合作專案。",
    "partnerInquiry.badge": "合作申請",
    "partnerInquiry.title": "告訴我們你想如何與 LUKKEY 合作。",
    "partnerInquiry.subtitle":
      "這是商務合作入口，和客戶支援請求分開處理。",
    "partnerInquiry.point1": "分配給對應的合作負責人",
    "partnerInquiry.point2": "依合作類型自動預填模板",
    "partnerInquiry.point3": "LUKKEY 團隊將透過郵件跟進",
    "partnerInquiry.program.affiliate": "推薦返佣",
    "partnerInquiry.program.reseller": "經銷商",
    "partnerInquiry.program.cobranding": "聯名合作",
    "partnerInquiry.affiliate.seoTitle": "LUKKEY 推薦返佣申請 | 創作者合作",
    "partnerInquiry.affiliate.seoDescription":
      "申請成為 LUKKEY 創作者或推薦合作夥伴。",
    "partnerInquiry.affiliate.badge": "創作者推薦合作",
    "partnerInquiry.affiliate.title": "成為 LUKKEY 創作者合作夥伴。",
    "partnerInquiry.affiliate.subtitle":
      "面向創作者、測評內容、教育內容和社群經營者的輕量申請流程。",
    "partnerInquiry.affiliate.point1": "申請流程簡單友善",
    "partnerInquiry.affiliate.point2": "說明你的通路和受眾匹配度",
    "partnerInquiry.affiliate.point3": "LUKKEY 團隊會透過郵件跟進",
    "partnerInquiry.affiliate.messageLabel": "介紹你的內容方向",
    "partnerInquiry.affiliate.submit": "提交創作者合作申請",
    "partnerInquiry.affiliate.success": "創作者合作申請已送出。",
    "partnerInquiry.reseller.seoTitle": "LUKKEY 經銷商申請 | 商務合作",
    "partnerInquiry.reseller.seoDescription":
      "申請成為 LUKKEY 經銷商或銷售通路合作夥伴。",
    "partnerInquiry.reseller.badge": "經銷商申請",
    "partnerInquiry.reseller.title": "申請成為 LUKKEY 經銷商。",
    "partnerInquiry.reseller.subtitle":
      "面向商店、分銷商和銷售通路的簡潔商務線索流程。",
    "partnerInquiry.reseller.point1": "收集公司資訊和銷售地區",
    "partnerInquiry.reseller.point2": "確認通路匹配度和預計銷量",
    "partnerInquiry.reseller.point3": "由合作銷售團隊專業跟進",
    "partnerInquiry.reseller.messageLabel": "商務需求",
    "partnerInquiry.reseller.submit": "提交經銷商申請",
    "partnerInquiry.reseller.success": "經銷商申請已送出。",
    "partnerInquiry.cobranding.seoTitle": "LUKKEY 聯名合作諮詢 | 品牌合作",
    "partnerInquiry.cobranding.seoDescription":
      "發起 LUKKEY 聯名合作諮詢。",
    "partnerInquiry.cobranding.badge": "品牌聯名合作",
    "partnerInquiry.cobranding.title": "發起一次聯名合作溝通。",
    "partnerInquiry.cobranding.subtitle":
      "面向活動、產品和發布合作的專業商務入口。",
    "partnerInquiry.cobranding.point1": "說明品牌、活動和發布時間",
    "partnerInquiry.cobranding.point2": "整理設計或產品需求",
    "partnerInquiry.cobranding.point3": "由 LUKKEY 合作團隊評估跟進",
    "partnerInquiry.cobranding.messageLabel": "合作簡報",
    "partnerInquiry.cobranding.submit": "提交聯名合作諮詢",
    "partnerInquiry.cobranding.success": "聯名合作諮詢已送出。",
    "partnerInquiry.form.name": "姓名",
    "partnerInquiry.form.email": "信箱",
    "partnerInquiry.form.company": "公司 / 通路",
    "partnerInquiry.form.website": "網站或社群連結",
    "partnerInquiry.form.channel": "主要通路或社群連結",
    "partnerInquiry.form.audience": "受眾或社群",
    "partnerInquiry.form.region": "銷售地區",
    "partnerInquiry.form.volume": "預計月銷量",
    "partnerInquiry.form.timeline": "目標上線時間",
    "partnerInquiry.form.program": "合作類型",
    "partnerInquiry.form.message": "合作詳情",
    "partnerInquiry.form.submit": "提交合作申請",
    "partnerInquiry.form.submitting": "正在提交",
    "partnerInquiry.validation.required": "此欄位為必填。",
    "partnerInquiry.validation.email": "請輸入有效信箱地址。",
    "partnerInquiry.success": "合作申請已送出，我們會透過郵件跟進。",
    "partnerInquiry.error": "提交失敗，請稍後再試。",
    "partnerInquiry.prefill.affiliate":
      "我想申請 LUKKEY 推薦返佣合作計畫。\n\n通路 / 受眾：\n所在地區：\n期望合作形式：\n相關連結：",
    "partnerInquiry.prefill.reseller":
      "我想申請 LUKKEY 經銷商合作計畫。\n\n公司 / 店鋪名稱：\n銷售通路：\n所在地區：\n預計月銷量：\n相關連結：",
    "partnerInquiry.prefill.cobranding":
      "我想溝通 LUKKEY 聯名合作。\n\n品牌 / 專案名稱：\n活動想法：\n目標上線時間：\n設計或產品需求：\n相關連結：",
  },
  fr: { ...partnerInquiryLocaleTranslations.fr, ...partnerFooterTranslations.fr, ...partnerPageLocaleTranslations.fr },
  es: { ...partnerInquiryLocaleTranslations.es, ...partnerFooterTranslations.es, ...partnerPageLocaleTranslations.es },
  ar: { ...partnerInquiryLocaleTranslations.ar, ...partnerFooterTranslations.ar, ...partnerPageLocaleTranslations.ar },
  ja: { ...partnerInquiryLocaleTranslations.ja, ...partnerFooterTranslations.ja, ...partnerPageLocaleTranslations.ja },
  ru: { ...partnerInquiryLocaleTranslations.ru, ...partnerFooterTranslations.ru, ...partnerPageLocaleTranslations.ru },
  ko: { ...partnerInquiryLocaleTranslations.ko, ...partnerFooterTranslations.ko, ...partnerPageLocaleTranslations.ko },
  pt: { ...partnerInquiryLocaleTranslations.pt, ...partnerFooterTranslations.pt, ...partnerPageLocaleTranslations.pt },
  "pt-BR": {
    ...partnerInquiryLocaleTranslations["pt-BR"],
    ...partnerFooterTranslations["pt-BR"],
    ...partnerPageLocaleTranslations["pt-BR"],
  },
  it: { ...partnerInquiryLocaleTranslations.it, ...partnerFooterTranslations.it, ...partnerPageLocaleTranslations.it },
  de: { ...partnerInquiryLocaleTranslations.de, ...partnerFooterTranslations.de, ...partnerPageLocaleTranslations.de },
  hi: { ...partnerInquiryLocaleTranslations.hi, ...partnerFooterTranslations.hi, ...partnerPageLocaleTranslations.hi },
  mn: { ...partnerInquiryLocaleTranslations.mn, ...partnerFooterTranslations.mn, ...partnerPageLocaleTranslations.mn },
  th: { ...partnerInquiryLocaleTranslations.th, ...partnerFooterTranslations.th, ...partnerPageLocaleTranslations.th },
  uk: { ...partnerInquiryLocaleTranslations.uk, ...partnerFooterTranslations.uk, ...partnerPageLocaleTranslations.uk },
  vi: { ...partnerInquiryLocaleTranslations.vi, ...partnerFooterTranslations.vi, ...partnerPageLocaleTranslations.vi },
  id: { ...partnerInquiryLocaleTranslations.id, ...partnerFooterTranslations.id, ...partnerPageLocaleTranslations.id },
  tl: { ...partnerInquiryLocaleTranslations.tl, ...partnerFooterTranslations.tl, ...partnerPageLocaleTranslations.tl },
  bn: { ...partnerInquiryLocaleTranslations.bn, ...partnerFooterTranslations.bn, ...partnerPageLocaleTranslations.bn },
};
